var OTD_SITE_URL,
  SERVER_PATH,
  Scripturl,
  res,
  res1,
  scid,
  SITE_FILE_URL,
  local = 0,
  path = __st.pageurl,
  cart = 1,
  product = path.search("/products/"),
  shopName = Shopify.shop;
1 == local
  ? ((SITE_FILE_URL =
      "http://localhost/appsonrent-apps/on-time-delivery/on-time-delivery.php"),
    (OTD_SITE_URL = path =
      "http://localhost/appsonrent-apps/on-time-delivery/"))
  : ((path =
      (SERVER_PATH = "") == SERVER_PATH
        ? "https://otd.appsonrent.com/on-time-delivery/"
        : "https://devodd.identixweb.com/on-time-delivery/"),
    (scid =
      void 0 === document.currentScript
        ? ""
        : 1 < (res = (Scripturl = document.currentScript.src).split("&")).length
        ? (res1 = res[1].split("="))[1]
        : ""),
    (SITE_FILE_URL = path + "on-time-delivery.php"));
var minDate,
  min_date,
  maxDate,
  currentDate,
  data,
  loadCount = 0,
  on_time_required_delivery_date = "",
  on_time_use_time_option = "",
  on_time_appsStatus = 0,
  sp_settings = "",
  oddLocationCalanderSettings = [],
  delivery_days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  oddStorePickup = "",
  oddItemsData = [],
  map_load = 0,
  map_js_load = 0,
  resultJson = "",
  eddResultJson = "",
  jQueryOTD = "",
  scriptsOTD = [],
  currentTime = "",
  deliveryTimeArr = [],
  daysArr = [],
  weekDays = [],
  formatedDisableDateArr = [],
  formatedDisableDayArr = [];
window.Checkout &&
  window.Checkout.jQuery &&
  (jQueryOTD = window.Checkout.jQuery);
{
  function IW_dt_loadJavascriptAsynch(e) {
    var t = document.createElement("script");
    return (
      (t.type = "text/javascript"),
      (t.src = e),
      t.readyState
        ? (t.onreadystatechange = function () {
            ("complete" != this.readyState && "loaded" != this.readyState) ||
              ((t.onreadystatechange = null),
              (jQueryOTD = window.jQuery),
              console.log("IE jquery load OTD"),
              IW_dt_handler());
          })
        : (t.onload = function () {
            (jQueryOTD = window.jQuery),
              console.log("App jquery load OTD"),
              IW_dt_handler();
          }),
      void 0 !== t && document.getElementsByTagName("head")[0].appendChild(t),
      t
    );
  }
  function IW_dt_handler() {
    var e, t;
    ++loadCount < scriptsOTD.length
      ? IW_dt_loadJavascriptAsynch(scriptsOTD[loadCount])
      : (!jQueryOTD.fn.bootstrapDP &&
          jQueryOTD.fn.datepicker &&
          jQueryOTD.fn.datepicker.noConflict &&
          ((e = jQueryOTD.fn.datepicker.noConflict()),
          (jQueryOTD.fn.bootstrapDP = e)),
        (e = __st.pageurl),
        0 < (cart = 1) && product < 0
          ? jQueryOTD("#delivery-app-root").length ||
            jQueryOTD("form[action='/cart?locale=en']").length
            ? display_calendar_onTime()
            : (t = setInterval(function () {
                (jQueryOTD("#delivery-app-root").length ||
                  jQueryOTD("form[action='/cart?locale=en']").length) &&
                  (clearInterval(t), display_calendar_onTime());
              }, 200))
          : (0 < product || "product" == __st.p) && estimated_delivery_date());
  }
  function IW_dt_load_css() {
    ($font_awesome =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css"),
      IW_dt_urlExists($font_awesome, function (e) {
        LoadStyle(e ? $font_awesome : path + "assets/css/font-awesome.css");
      }),
      LoadStyle("https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/css/bootstrap-datepicker.min.css"),
      LoadStyle(path + "assets/css/on-time-delivery.min.css");
  }
  function IW_dt_urlExists(e, t) {
    var a = new XMLHttpRequest();
    (a.onreadystatechange = function () {
      4 === a.readyState && t(200 == a.status);
    }),
      a.open("HEAD", e),
      a.send();
  }
  function LoadStyle(e) {
    var t = document.getElementsByTagName("head")[0],
      a = document.createElement("link");
    (a.rel = "stylesheet"),
      (a.type = "text/css"),
      (a.href = e),
      (a.media = "all"),
      t.appendChild(a);
  }
  function oddJsLoad(e, t) {
    var a;
    document.getElementById(t) ||
      (((a = document.createElement("script")).type = "text/javascript"),
      (a.async = !1),
      (a.src = e),
      (a.id = t),
      (t = document.getElementsByTagName("script")[0]).parentNode.insertBefore(
        a,
        t
      ));
  }
  (0 < cart || 0 < product) &&
    ("east-lothian-deli-box.myshopify.com" == shopName ||
    "balloon-up-online.myshopify.com" == shopName ||
    "wagyu-mall-online.myshopify.com" == shopName ||
    "chapa-esa-flor.myshopify.com" == shopName ||
    "soul-souper.myshopify.com" == shopName ||
    "my-mums-cookies.myshopify.com" == shopName ||
    "granville-island-delivery-company.myshopify.com" == shopName ||
    "hydrocleann.myshopify.com" == shopName ||
    "grocery2u-ca.myshopify.com" == shopName ||
    "homefield-grange-at-home.myshopify.com" == shopName ||
    "cut-butchery.myshopify.com" == shopName ||
    "3eee7e-2.myshopify.com" == shopName ||
    "birchtree-at-home.myshopify.com" == shopName ||
    "yippiii.myshopify.com" == shopName
      ? (console.log("iff enter"),
        (loadCount = 1),
        (scriptsOTD = [
          "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
          path + "assets/js/on-time-delivery-bootstrap-datepicker.js",
          "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.0.1/js/bootstrap.min.js",
        ]),
        window.jQuery ||
          "hydrocleann.myshopify.com" != shopName ||
          (loadCount = 0),
        IW_dt_loadJavascriptAsynch(scriptsOTD[loadCount]),
        IW_dt_load_css())
      : "undefined" == typeof jQuery
      ? (console.log("jquery undefined"),
        IW_dt_loadJavascriptAsynch(
          (scriptsOTD = [
            "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
            path + "assets/js/on-time-delivery-bootstrap-datepicker.js",
            "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.0.1/js/bootstrap.min.js",
          ])[loadCount]
        ),
        IW_dt_load_css())
      : (console.log("App datepicker load"),
        "product" == __st.p
          ? "undefined" != typeof jQuery ||
            ("halal-with-hew.myshopify.com" == shopName &&
              "rachelefiori1977.myshopify.com" == shopName &&
              "homeward-bound-pet-food-delivery-halifax.myshopify.com" ==
                shopName &&
              "natalia-s-rustic-kitchen.myshopify.com" == shopName &&
              "feyarozy.myshopify.com" == shopName &&
              "interflora-toluca.myshopify.com" == shopName &&
              "douart-bakery.myshopify.com" == shopName &&
              "so-fresh-bakehouse.myshopify.com" == shopName &&
              "balsamine-atelier.myshopify.com" == shopName &&
              "alyusoff-sg.myshopify.com" == shopName &&
              "sweetnnice.myshopify.com" == shopName &&
              "warsaw-balloonmakers.myshopify.com" == shopName)
            ? (console.log("product page"),
              (jQueryOTD = window.jQuery),
              IW_dt_handler())
            : (console.log("product page"),
              scriptsOTD.push("https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"),
              IW_dt_loadJavascriptAsynch(scriptsOTD[loadCount]),
              IW_dt_load_css())
          : 0 < cart &&
            product < 0 &&
            (console.log("cart page"),
            scriptsOTD.push("https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"),
            scriptsOTD.push(
              path + "assets/js/on-time-delivery-bootstrap-datepicker.js"
            ),
            IW_dt_loadJavascriptAsynch(scriptsOTD[loadCount]),
            IW_dt_load_css())));
}
function display_calendar_onTime() {
  jQueryOTD.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: "json",
    async: !1,
    success: function (e) {
      var t = e.items;
      if (0 == t.length) return !0;
      for (var a = 0; a < t.length; a++) oddItemsData.push(t[a].product_id);
      e = {};
      (e.scid = scid),
        (e.shop = shopName),
        (e.cartData = oddItemsData),
        (e.method_name = "get_shipping_data"),
        jQueryOTD.ajax({
          type: "POST",
          url: SITE_FILE_URL,
          data: e,
          success: function (e) {
            if (
              "0" == (resultJson = JSON.parse(e)).date_picker_status ||
              "0" == resultJson.charge_approve
            )
              return !0;
            if (
              "success" == resultJson.msg &&
              "1" == resultJson.charge_approve
            ) {
              var t = resultJson.max_days,
                a = resultJson.min_day_value;
              if (
                "1" == resultJson.plan_type &&
                "1" == resultJson.sp_app_status
              ) {
                if (
                  (oddJsLoad(
                    path + "assets/js/store_pickup.js",
                    "otdStorePickupJs"
                  ),
                  (sp_settings = resultJson.sp_setting.sp_settings_data),
                  0 < jQueryOTD(".iweb-order-delivery-dt-pro").length
                    ? jQueryOTD(".iweb-order-delivery-dt-pro").html(
                        resultJson.sp_setting_html
                      )
                    : jQueryOTD(
                        "#delivery-app-root,form[action='/cart?locale=en']"
                      ).append(resultJson.sp_setting_html),
                  "1" == resultJson.shipping_status)
                )
                  return shipping_calender_show(t, a), !0;
              } else {
                0 < jQueryOTD(".iweb-order-delivery-dt-pro").length
                  ? jQueryOTD(".iweb-order-delivery-dt-pro").append(
                      "<div class='iw-order-delivery-dt-main'><div class='otd_container'></div></div>"
                    )
                  : jQueryOTD(".iweb-order-delivery-dt-pro").length ||
                    jQueryOTD(
                      "#delivery-app-root,form[action='/cart?locale=en']"
                    ).append(
                      "<div class='iw-order-delivery-dt-main'><div class='otd_container'></div></div>"
                    );
                e = resultJson.custom_css;
                e &&
                  jQueryOTD(".iw-order-delivery-dt-main").append(
                    "<style>" + e + "</style>"
                  );
              }
              if (
                (jQueryOTD(
                  "<div class='calendar_heading' style='text-align:center'>" +
                    resultJson.calendar_heading +
                    "</div>"
                ).insertBefore(".iw-order-delivery-dt-pro"),
                "1" == resultJson.date_picker_status &&
                  (jQueryOTD(
                    'form[action*="/cart"] [name="checkout"],form[action="/cart?locale=en"] [name="checkout"]'
                  ).removeAttr("disabled"),
                  "1" == resultJson.shipping_status))
              )
                return shipping_calender_show(t, a, 1), !0;
            }
          },
        });
    },
  });
}
function estimated_delivery_date() {
  var e;
  jQueryOTD("form[action*='/cart/add']") &&
    "product" == __st.p &&
    (((e = {}).scid = scid),
    (e.shop = shopName),
    (e.method_name = "getSettings"),
    (e.new_method = "eddSettings"),
    jQueryOTD.ajax({
      type: "POST",
      url: SITE_FILE_URL,
      data: e,
      success: function (e) {
        var g,
          r,
          i,
          t,
          a,
          T,
          b,
          O,
          s,
          d,
          n,
          o,
          l,
          _,
          j,
          w,
          m,
          u,
          Q,
          c,
          y,
          p,
          D,
          f,
          x,
          h,
          A,
          I,
          v,
          S,
          k,
          J,
          R,
          F,
          L,
          C,
          N,
          M,
          P,
          E,
          q,
          V,
          H,
          W,
          z;
        (e = JSON.parse(e)),
          (eddResultJson = e.data),
          void 0 !== e.data &&
            "success" == e.msg &&
            "0" != e.date_picker_status &&
            "0" != e.charge_approve &&
            eddResultJson.date_picker_status &&
            "1" == eddResultJson.date_picker_status &&
            jQueryOTD("form[action*='/cart/add']") &&
            ((g = jQueryOTD("form[action*='/cart/add']")),
            "1" == eddResultJson.show_edd_datetime &&
              ((a = []),
              (o = (y = new Date(
                eddResultJson.timezonecurrenttime24
              )).getMinutes()),
              (c = y.getHours() + ":" + o),
              (p = eddResultJson.cutoff_time),
              (currentDate = dateObjToString(y)),
              (currentTime = dateObjToTimeString(y)),
              (e = eddResultJson.min_day_value),
              "object" == typeof (min_date = addDays(currentDate, e)) &&
                (min_date =
                  min_date.getFullYear() +
                  "-" +
                  (t = (t = min_date.getMonth() + 1) < 10 ? "0" + t : t) +
                  "-" +
                  (min_date.getDate() < 10
                    ? "0" + min_date.getDate()
                    : min_date.getDate())),
              (r = find_separator_date((minDate = eddResultJson.min_date))),
              (o = find_separator_date((i = eddResultJson.date_format))),
              (minDate = dateFormatConvert(i, "yy-mm-dd", r, "-", minDate)),
              (e = parseInt(eddResultJson.max_date)),
              (t = new Date(minDate)),
              (t =
                (t = (t = (maxDate = addDays(t, e)).getDate()).toString())
                  .length < 2
                  ? "0".concat(t)
                  : t),
              (e =
                (e = (maxDate.getMonth() + 1).toString()).length < 2
                  ? "0".concat(e)
                  : e),
              (maxDate = maxDate.getFullYear() + "-" + e + "-" + t),
              "" !== (a = eddResultJson.extra_no_available.split(","))[0] &&
                a.forEach(function (e) {
                  e = dateFormatConvert(i, "yy-mm-dd", r, "-", e);
                  var t = new Date(e),
                    a = t.getFullYear(),
                    e = (e = t.getMonth() + 1) < 10 ? "0" + e : e,
                    t = t.getDate() < 10 ? "0" + t.getDate() : t.getDate();
                  formatedDisableDateArr.push(a + "-" + e + "-" + t);
                }),
              (minDate = recursiveOnDisableDates(
                minDate,
                formatedDisableDateArr
              )),
              (a = eddResultJson.invalid_day),
              (formatedDisableDayArr = a.split(",")),
              (minDate = recursiveOnDisableDays(
                minDate,
                formatedDisableDayArr,
                formatedDisableDateArr
              )),
              (holiday_minDate =
                "1" == eddResultJson.required_holiday_interval ? minDate : ""),
              (T = eddResultJson.timer_status_format),
              "NULL" !== eddResultJson.timer_status_format &&
                ((W = date_change_onTimeDel_function_edd(
                  minDate,
                  i,
                  o,
                  eddResultJson
                )),
                (deliveryTimeArr = W.tempObj_12),
                (deliveryTimeArr_24 = W.tempObj_24),
                null != deliveryTimeArr_24 &&
                0 == Object.keys(deliveryTimeArr_24).length
                  ? ((minDate =
                      "object" ==
                      typeof (minDate = recursiveOnDisableDays(
                        (minDate = recursiveOnDisableDates(
                          (minDate = addDays(minDate, 1)),
                          formatedDisableDateArr
                        )),
                        formatedDisableDayArr,
                        formatedDisableDateArr
                      ))
                        ? dateObjToString(minDate)
                        : minDate),
                    (deliveryTimeArr = eddResultJson.delivery_time.time_24),
                    (deliveryTimeArr_24 = eddResultJson.delivery_time.time))
                  : null != deliveryTimeArr_24 &&
                    0 == Object.keys(W.tempObj_12).length &&
                    0 == Object.keys(deliveryTimeArr_24).length
                  ? (deliveryTimeArr = W)
                  : null != deliveryTimeArr_24 &&
                    0 == Object.keys(W.tempObj_12).length &&
                    0 != Object.keys(deliveryTimeArr_24).length &&
                    (deliveryTimeArr = W.tempObj_24)),
              "NULL" == eddResultJson.timer_status_format &&
                "1" == eddResultJson.cutoff_time_status &&
                ((l = eddResultJson.cutoff_time),
                (_ = []),
                minDate == currentDate
                  ? 0 ==
                      (d = recursiveOnDeliveryTime_cutoff_zero(
                        l,
                        deliveryTimeArr,
                        "cutoff"
                      )).length &&
                    (minDate =
                      "object" ==
                      typeof (minDate = recursiveOnDisableDays(
                        (minDate = recursiveOnDisableDates(
                          (minDate = addDays(minDate, 1)),
                          formatedDisableDateArr
                        )),
                        formatedDisableDayArr,
                        formatedDisableDateArr
                      ))
                        ? dateObjToString(minDate)
                        : minDate)
                  : minDate == min_date &&
                    1 == eddResultJson.cutoff_time_min_day &&
                    0 ==
                      (d = recursiveOnDeliveryTime_cutoff_zero(
                        l,
                        deliveryTimeArr,
                        "cutoff"
                      )).length &&
                    (minDate =
                      "object" ==
                      typeof (minDate = recursiveOnDisableDays(
                        (minDate = recursiveOnDisableDates(
                          (minDate = addDays(minDate, 1)),
                          formatedDisableDateArr
                        )),
                        formatedDisableDayArr,
                        formatedDisableDateArr
                      ))
                        ? dateObjToString(minDate)
                        : minDate)),
              "0" == T
                ? (minDate == currentDate &&
                    (minDate =
                      "object" ==
                      typeof (minDate = recursiveOnDisableDays(
                        (minDate = recursiveOnDisableDates(
                          minDate,
                          formatedDisableDateArr
                        )),
                        formatedDisableDayArr,
                        formatedDisableDateArr
                      ))
                        ? dateObjToString(minDate)
                        : minDate),
                  "1" == eddResultJson.cutoff_time_status &&
                    ((l = eddResultJson.cutoff_time),
                    (_ = []),
                    minDate == currentDate
                      ? (0 ==
                        (d = recursiveOnDeliveryTime_cutoff_zero(
                          l,
                          deliveryTimeArr,
                          "cutoff"
                        )).length
                          ? ((minDate =
                              "object" ==
                              typeof (minDate = recursiveOnDisableDays(
                                (minDate = recursiveOnDisableDates(
                                  (minDate = addDays(minDate, 1)),
                                  formatedDisableDateArr
                                )),
                                formatedDisableDayArr,
                                formatedDisableDateArr
                              ))
                                ? dateObjToString(minDate)
                                : minDate),
                            min_date < minDate && (_ = defaultDeliveryTimes))
                          : (_ = d),
                        0 == _.length &&
                          (minDate =
                            "object" ==
                            typeof (minDate = recursiveOnDisableDays(
                              (minDate = recursiveOnDisableDates(
                                (minDate = addDays(minDate, 1)),
                                formatedDisableDateArr
                              )),
                              formatedDisableDayArr,
                              formatedDisableDateArr
                            ))
                              ? dateObjToString(minDate)
                              : minDate))
                      : minDate == min_date &&
                        1 == eddResultJson.cutoff_time_min_day &&
                        ((d = recursiveOnDeliveryTime_cutoff_zero(
                          l,
                          deliveryTimeArr,
                          "cutoff"
                        )),
                        0 < _.length &&
                          (minDate =
                            "object" ==
                            typeof (minDate = recursiveOnDisableDays(
                              (minDate = recursiveOnDisableDates(
                                minDate,
                                formatedDisableDateArr
                              )),
                              formatedDisableDayArr,
                              formatedDisableDateArr
                            ))
                              ? dateObjToString(minDate)
                              : minDate),
                        0 == d.length &&
                          (minDate =
                            "object" ==
                            typeof (minDate = recursiveOnDisableDays(
                              (minDate = recursiveOnDisableDates(
                                (minDate = addDays(minDate, 1)),
                                formatedDisableDateArr
                              )),
                              formatedDisableDayArr,
                              formatedDisableDateArr
                            ))
                              ? dateObjToString(minDate)
                              : minDate))))
                : "1" == T
                ? ((daysArray = [
                    "sunday",
                    "monday",
                    "tuesday",
                    "wednesday",
                    "thursday",
                    "friday",
                    "saturday",
                  ]),
                  (o = (y = new Date(minDate)).getDay()),
                  (o = daysArray[o]),
                  (b = (W = eddResultJson.delivery_time)[o].start_time),
                  (O = W[o].end_time),
                  (O =
                    12 == eddResultJson.time_display_format
                      ? ((b = oddt_convert_24_to_12(b[0].split(":"))),
                        oddt_convert_24_to_12(O[0].split(":")))
                      : ((b = b[0]), O[0])),
                  eddResultJson.order_data,
                  (s = []),
                  minDate == currentDate &&
                    (jQueryOTD.each(deliveryTimeArr, function (e, t) {
                      currentTime < t && s.push(t);
                    }),
                    0 < s.length
                      ? (deliveryTimeArr = s)
                      : 0 == s.length &&
                        ((minDate =
                          "object" ==
                          typeof (minDate = recursiveOnDisableDays(
                            (minDate = recursiveOnDisableDates(
                              (minDate =
                                "object" ==
                                typeof (minDate = addDays(minDate, 1))
                                  ? dateObjToString(minDate)
                                  : minDate),
                              formatedDisableDateArr
                            )),
                            formatedDisableDayArr,
                            formatedDisableDateArr
                          ))
                            ? dateObjToString(minDate)
                            : minDate),
                        (n = (y = new Date(minDate)).getDay()),
                        (o = daysArray[n]),
                        (deliveryTimeArr = W[o].start_time))),
                  "1" == eddResultJson.cutoff_time_status &&
                    ((l = eddResultJson.cutoff_time),
                    (_ = []),
                    dateObjToString(addDays(currentDate, 1)),
                    (deliveryTimeArr = W[o].start_time),
                    minDate == currentDate
                      ? (0 <
                          (d = recursiveOnDeliveryTime_cutoff_one(
                            l,
                            deliveryTimeArr,
                            "cutoff"
                          )).length && (deliveryTimeArr = d),
                        0 == d.length &&
                          ((minDate =
                            "object" ==
                            typeof (minDate = recursiveOnDisableDays(
                              (minDate = recursiveOnDisableDates(
                                (minDate =
                                  "object" ==
                                  typeof (minDate = addDays(minDate, 1))
                                    ? dateObjToString(minDate)
                                    : minDate),
                                formatedDisableDateArr
                              )),
                              formatedDisableDayArr,
                              formatedDisableDateArr
                            ))
                              ? dateObjToString(minDate)
                              : minDate),
                          (n = (y = new Date(minDate)).getDay()),
                          (o = daysArray[n]),
                          (deliveryTimeArr = W[o].start_time)))
                      : minDate == min_date &&
                        "1" == eddResultJson.cutoff_time_min_day &&
                        ((minDate =
                          "object" ==
                          typeof (minDate = recursiveOnDisableDays(
                            (minDate = recursiveOnDisableDates(
                              (minDate =
                                "object" ==
                                typeof (minDate = addDays(minDate, 1))
                                  ? dateObjToString(minDate)
                                  : minDate),
                              formatedDisableDateArr
                            )),
                            formatedDisableDayArr,
                            formatedDisableDateArr
                          ))
                            ? dateObjToString(minDate)
                            : minDate),
                        (n = (y = new Date(minDate)).getDay()),
                        (o = daysArray[n]),
                        (deliveryTimeArr = W[o].start_time))))
                : "2" == T &&
                  "1" == eddResultJson.cutoff_time_status &&
                  ((l = eddResultJson.cutoff_time),
                  (_ = []),
                  minDate == currentDate
                    ? parseFloat(c) >= parseFloat(p) &&
                      (minDate =
                        "object" ==
                        typeof (minDate = recursiveOnDisableDays(
                          (minDate = recursiveOnDisableDates(
                            (minDate = addDays(minDate, 1)),
                            formatedDisableDateArr
                          )),
                          formatedDisableDayArr,
                          formatedDisableDateArr
                        ))
                          ? dateObjToString(minDate)
                          : minDate)
                    : minDate == min_date &&
                      1 == eddResultJson.cutoff_time_min_day &&
                      parseFloat(c) >= parseFloat(p) &&
                      (minDate =
                        "object" ==
                        typeof (minDate = recursiveOnDisableDays(
                          (minDate = recursiveOnDisableDates(
                            (minDate = addDays(minDate, 1)),
                            formatedDisableDateArr
                          )),
                          formatedDisableDayArr,
                          formatedDisableDateArr
                        ))
                          ? dateObjToString(minDate)
                          : minDate)),
              "string" == typeof minDate
                ? (minDate.includes("-") ||
                    minDate.includes("/") ||
                    minDate.includes(".")) &&
                  (j = minDate)
                : "object" == typeof minDate && (j = dateObjToString(minDate)),
              (c = find_separator_date(j)),
              (w = j.split(c)),
              "2" == T && null != deliveryTimeArr
                ? (m = deliveryTimeArr)
                : ((u = []), (u = deliveryTimeArr)),
              (daysArr =
                "" != eddResultJson.dates_name
                  ? eddResultJson.months_name.split(",")
                  : [
                      "Jan",
                      "Fab",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ]),
              (weekDays =
                "" != eddResultJson.months_name
                  ? eddResultJson.dates_name.split(",")
                  : [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ]),
              j.includes("/") &&
                "string" == typeof j &&
                (j = (j = j.replaceAll("/", "-"))
                  .split("-")
                  .reverse()
                  .join("-")),
              (p = new Date(j)),
              (Q = weekDays[p.getUTCDay()]),
              "24" == eddResultJson.time_display_format &&
                "1" == T &&
                ((weekDay_24 = ""),
                (c = u[0].split("-")),
                (v = (y = new Date(minDate)).getDay()),
                (p = daysArray[v]),
                (weekDay_24 = weekDays[y.getDay()]),
                (v = eddResultJson.delivery_time[p].start_time),
                (D = eddResultJson.delivery_time[p].end_time),
                (f = v.indexOf(c[0])),
                (finalStartDeliveryTime_24 = []),
                (finalEndDeliveryTime_24 = []),
                jQueryOTD.each(v, function (e, t) {
                  f == e &&
                    (finalStartDeliveryTime_24.push(t),
                    finalEndDeliveryTime_24.push(D[e]));
                })),
              (x = eddResultJson.edd_editor_text),
              (h = $("<div/>")),
              x &&
                "" != x &&
                ((S = $("<div/>").html(x)),
                $(S[0])
                  .children()
                  .each(function (e, t) {
                    $(t)[0].textContent.includes("{{timer_day_hour}}") ||
                    $(t)[0].textContent.includes("{{day_hour}}") ||
                    $(t)[0].textContent.includes("{{date_time}}")
                      ? ($(t)[0].textContent.includes("{{timer_day_hour}}") &&
                          ($(t).addClass("edd_timerDayHour_class"),
                          h.append($(t)[0])),
                        $(t)[0].textContent.includes("{{day_hour}}") &&
                          ($(t).addClass("edd_dayHour_class"),
                          h.append($(t)[0])),
                        $(t)[0].textContent.includes("{{date_time}}") &&
                          ($(t).addClass("edd_dateTime_class"),
                          h.append($(t)[0])))
                      : h.append($(t)[0]);
                  }),
                (x = h[0].innerHTML)),
              (A = ""),
              "2" !== T
                ? x &&
                  "" != x &&
                  ((I = j.split("-")),
                  "" != u &&
                    (1 == T && void 0 !== deliveryTimeArr_24
                      ? ((v = (z = deliveryTimeArr_24[0].split("-"))[0].split(
                          ":"
                        )),
                        (S = z[1].split(":")),
                        (z[0] = v[0].length < 2 ? "0".concat(v[0]) : v[0]),
                        (z[1] = S[0].length < 2 ? "0".concat(S[0]) : S[0]),
                        (k = v))
                      : 0 == T &&
                        (((z = deliveryTimeArr_24[0].split(":"))[0] =
                          z[0].length < 2 ? "0".concat(z[0]) : z[0]),
                        (z[1] = z[1].length < 2 ? "0".concat(z[1]) : z[1]),
                        ((k = u[0].split(":"))[0] =
                          k[0].length < 2 ? "0".concat(k[0]) : k[0]),
                        (k[1] = k[1].length < 2 ? "0".concat(k[1]) : k[1])),
                    (A = void 0 !== z ? z[0] : "")),
                  (J = ["{{timer_day_hour}}", "{{day_hour}}", "{{date_time}}"]),
                  (R = new Date(I[0], I[1] - 1, I[2], A).getTime()),
                  (q = E = P = M = N = C = L = F = 0),
                  (V = setInterval(function () {
                    var e = new Date().getTime(),
                      t = R - e;
                    t < 0 &&
                      (t =
                        new Date(
                          I[0],
                          I[1] - 1,
                          Number(I[2]) + 2,
                          A
                        ).getTime() - e),
                      (F = Math.floor(t / 864e5)),
                      (L = Math.floor((t % 864e5) / 36e5)),
                      (C = Math.floor((t % 36e5) / 6e4)),
                      (N = Math.floor((t % 6e4) / 1e3));
                    var a,
                      r,
                      i,
                      s,
                      d,
                      n,
                      o,
                      l,
                      _,
                      m,
                      u,
                      c,
                      y,
                      p,
                      D,
                      f,
                      h,
                      v = F < 10 ? "0" + F.toString() : F.toString(),
                      e = L < 10 ? "0" + L.toString() : L.toString();
                    C.toString(), N.toString();
                    (M = v ? v.charAt(0) : "0"),
                      (P = v ? v.charAt(1) : "0"),
                      (E = e ? e.charAt(0) : "0"),
                      (q = e ? e.charAt(1) : "0"),
                      jQueryOTD(document).find("#main_content").length
                        ? ((r =
                            "display: flex; font-weight: 600; border-radius: 10%; justify-content: center;"),
                          (i =
                            "color: #000000;font-size : " +
                            eddResultJson.edd_timer_appearance
                              .edd_timer_font_size +
                            "px"),
                          (s = ""),
                          "NULL" !== eddResultJson.timer_status_format &&
                            (s =
                              '<span class="edd_time_container_js" style="display: flex; margin-left: 10px; align-items: baseline;"><span class="edd_timer_days_items edd_timer_item" style="text-align: center;"><span style="display: flex;"><span class="position"><span class="timer_digit timer_digit_hourOne" style="' +
                              r +
                              '">' +
                              M +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_hourTwo" style="' +
                              r +
                              '">' +
                              P +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Days</span></span><span class="edd_timer_separator" style="' +
                              i +
                              '">:</span><span class="edd_timer_hour_items edd_timer_item" style="text-align: center;"><span style = "display:flex;"><span class="position"><span class="timer_digit timer_digit_minOne" style="' +
                              r +
                              '">' +
                              E +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_minTwo" style="' +
                              r +
                              '">' +
                              q +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Hrs</span></span></span>'),
                          (d =
                            0 == F
                              ? (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == L
                              ? (1 < F ? F + " days " : F + " day ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == C
                              ? (1 < F ? F + " days " : F + " day ") +
                                (1 < L ? L + " hours " : L + " hour ")
                              : (1 < F ? F + " days " : F + " day ") +
                                (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")),
                          0 < (c = []).length &&
                            ((c[0] = k[0].toString()),
                            (c[1] = k[1].toString()),
                            c[0].length < 2 && (c[0] = "0".concat(c[0]))),
                          (c = [
                            s,
                            d,
                            "1" == T && 0 < c.length
                              ? ("12" <= c[0] && "12" != c[0] && (c[0] -= 12),
                                c[0].toString().length < 2 &&
                                  (c[0] = "0".concat(c[0])),
                                "1" == eddResultJson.show_edd_between_dates
                                  ? ((v = (o = [
                                      "Sunday",
                                      "Monday",
                                      "Tuesday",
                                      "Wednesday",
                                      "Thursday",
                                      "Friday",
                                      "Saturday",
                                    ])[new Date(j).getDay()]),
                                    (l = minDate.split("-")),
                                    (m =
                                      o[
                                        (_ = addDays(
                                          (l = new Date(l[0], l[1] - 1, l[2])),
                                          eddResultJson.max_delivery_days
                                        )).getDay()
                                      ]),
                                    (u = (_ = dateObjToString(_)).split("-")),
                                    v +
                                      ", " +
                                      w[2] +
                                      " " +
                                      daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " TO " +
                                      m +
                                      ", " +
                                      u[2] +
                                      " " +
                                      daysArr[u[1] - 1] +
                                      " " +
                                      u[0])
                                  : "12" == eddResultJson.time_display_format
                                  ? Q +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    convert_time_24to12(deliveryTimeArr_24[0])
                                  : weekDay_24 +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    finalStartDeliveryTime_24 +
                                    " - " +
                                    finalEndDeliveryTime_24)
                              : "1" == eddResultJson.show_edd_between_dates
                              ? ((v = (o = [
                                  "Sunday",
                                  "Monday",
                                  "Tuesday",
                                  "Wednesday",
                                  "Thursday",
                                  "Friday",
                                  "Saturday",
                                ])[new Date(j).getDay()]),
                                (l = minDate.split("-")),
                                (m =
                                  o[
                                    (_ = addDays(
                                      (l = new Date(l[0], l[1] - 1, l[2])),
                                      eddResultJson.max_delivery_days
                                    )).getDay()
                                  ]),
                                (u = (_ = dateObjToString(_)).split("-")),
                                v +
                                  ", " +
                                  w[2] +
                                  " " +
                                  daysArr[w[1] - 1] +
                                  " " +
                                  w[0] +
                                  " TO " +
                                  m +
                                  ", " +
                                  u[2] +
                                  " " +
                                  daysArr[u[1] - 1] +
                                  " " +
                                  u[0])
                              : 1 == T
                              ? "12" == eddResultJson.time_display_format
                                ? ((a =
                                    void 0 !== deliveryTimeArr_24
                                      ? convert_time_24to12(
                                          deliveryTimeArr_24[0]
                                        )
                                      : b + " - " + O),
                                  Q +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    a)
                                : weekDay_24 +
                                  ", " +
                                  w[2] +
                                  " " +
                                  daysArr[w[1] - 1] +
                                  " " +
                                  w[0] +
                                  " - " +
                                  finalStartDeliveryTime_24 +
                                  " - " +
                                  finalEndDeliveryTime_24
                              : ((n = ""),
                                void 0 !== k && (n = " - " + k[0] + ":" + k[1]),
                                Q +
                                  ", " +
                                  w[2] +
                                  " " +
                                  daysArr[w[1] - 1] +
                                  " " +
                                  w[0] +
                                  n),
                          ]),
                          x &&
                            "" != x &&
                            (p = (y = x.includes(J[0])
                              ? x.replaceAll(J[0], c[0])
                              : x).includes(J[1])
                              ? y.replaceAll(J[1], c[1])
                              : y).includes(J[2]) &&
                            (p = p.replaceAll(J[2], c[2])),
                          jQueryOTD(document).find("#main_content").html(p),
                          jQueryOTD(document)
                            .find("#main_content .edd_timeDayHour_class")
                            .css("display", "block"),
                          jQueryOTD(document)
                            .find(".edd_time_container_js")
                            .attr(
                              "style",
                              "display: inline-flex; align-items: baseline;"
                            ),
                          "NULL" == eddResultJson.timer_status_format &&
                            ($(".edd_timerDayHour_class").remove(),
                            $(".edd_dayHour_class").remove()),
                          eddResultJson.edd_datetime_margin &&
                            ((D = eddResultJson.edd_datetime_margin),
                            jQueryOTD("#main_content").nextAll(
                              ".edd_dateTime_class"
                            ) &&
                              jQueryOTD("#main_content")
                                .nextAll(".edd_dateTime_class")
                                .css({
                                  margin:
                                    D.edd_datetime_margin_top +
                                    "px " +
                                    D.edd_datetime_margin_right +
                                    "px " +
                                    D.edd_datetime_margin_bottom +
                                    "px " +
                                    D.edd_datetime_margin_left +
                                    "px",
                                })),
                          eddResultJson.edd_timer_margin &&
                            ((f = eddResultJson.edd_timer_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_timeDayHour_class"
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_timeDayHour_class")
                                .css({
                                  margin:
                                    f.edd_timer_margin_top +
                                    "px " +
                                    f.edd_timer_margin_right +
                                    "px " +
                                    f.edd_timer_margin_bottom +
                                    "px " +
                                    f.edd_timer_margin_left +
                                    "px",
                                })),
                          eddResultJson.edd_timer_appearance &&
                            ((h = eddResultJson.edd_timer_appearance),
                            jQueryOTD(".timer_digit").css({
                              "background-color": h.edd_timer_digit_bg_color,
                              color: h.edd_timer_digit_color,
                              "font-size": h.edd_timer_font_size + "px",
                            }),
                            jQueryOTD(".timer_label").css({
                              "font-size": h.edd_timer_label_font_size + "px",
                              "font-weight": h.edd_timer_label_font_weight,
                              color: h.edd_timer_units_label_color,
                            }),
                            jQueryOTD(".edd_timer_separator").css({
                              color: h.edd_timer_separator_color,
                            })))
                        : ((a = []),
                          (r =
                            "display: flex; border-radius: 10%; justify-content: center;"),
                          (i =
                            "color: #000000;font-size : " +
                            eddResultJson.edd_timer_appearance
                              .edd_timer_font_size +
                            "px"),
                          (s = ""),
                          "NULL" !== eddResultJson.timer_status_format &&
                            (s =
                              '<span class="edd_time_container_js" style="display: inline-flex; align-items: baseline;"><span class="edd_timer_days_items edd_timer_item" style="text-align: center;"><span style="display: flex;"><span class="position"><span class="timer_digit timer_digit_hourOne" style="' +
                              r +
                              '">' +
                              M +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_hourTwo" style="' +
                              r +
                              '">' +
                              P +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Days</span></span><span class="edd_timer_separator" style="' +
                              i +
                              '">:</span><span class="edd_timer_hour_items edd_timer_item" style="text-align: center;"><span style = "display:flex;"><span class="position"><span class="timer_digit timer_digit_minOne" style="' +
                              r +
                              '">' +
                              E +
                              '</span></span><span class="position"><span class="timer_digit timer_digit_minTwo" style="' +
                              r +
                              '">' +
                              q +
                              '</span></span></span><span class="timer_label" style="color: #000000; font-weight: normal;">Hrs</span></span></span>'),
                          (d =
                            0 == F
                              ? (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == L
                              ? (1 < F ? F + " days " : F + " day ") +
                                (1 < C ? C + " minutes" : C + " minute")
                              : 0 == C
                              ? (1 < F ? F + " days " : F + " day ") +
                                (1 < L ? L + " hours " : L + " hour ")
                              : (1 < F ? F + " days " : F + " day ") +
                                (1 < L ? L + " hours " : L + " hour ") +
                                (1 < C ? C + " minutes" : C + " minute")),
                          void 0 !== k &&
                            ((a[0] = k[0].toString()),
                            (a[1] = k[1].toString()),
                            a[0].length < 2 && (a[0] = "0".concat(a[0]))),
                          (c = [
                            s,
                            d,
                            "1" == T && 0 < a.length
                              ? ("12" <= a[0] && "12" != a[0] && (a[0] -= "12"),
                                (a[0] = a[0].toString()),
                                (a[0] =
                                  a[0].length < 2 ? "0".concat(a[0]) : a[0]),
                                "1" == eddResultJson.show_edd_between_dates
                                  ? ((v = (o = [
                                      "Sunday",
                                      "Monday",
                                      "Tuesday",
                                      "Wednesday",
                                      "Thursday",
                                      "Friday",
                                      "Saturday",
                                    ])[new Date(j).getDay()]),
                                    (l = minDate.split("-")),
                                    (m =
                                      o[
                                        (_ = addDays(
                                          (l = new Date(l[0], l[1] - 1, l[2])),
                                          eddResultJson.max_delivery_days
                                        )).getDay()
                                      ]),
                                    (u = (_ = dateObjToString(_)).split("-")),
                                    v +
                                      ", " +
                                      w[2] +
                                      "-" +
                                      daysArr[w[1] - 1] +
                                      "-" +
                                      w[0] +
                                      " TO " +
                                      m +
                                      ", " +
                                      u[2] +
                                      "-" +
                                      daysArr[u[1] - 1] +
                                      "-" +
                                      u[0])
                                  : "12" == eddResultJson.time_display_format
                                  ? Q +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    convert_time_24to12(deliveryTimeArr_24[0])
                                  : weekDay_24 +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    " - " +
                                    finalStartDeliveryTime_24 +
                                    " - " +
                                    finalEndDeliveryTime_24)
                              : ((n = ""),
                                void 0 !== k &&
                                  (12 <= k[0] && 12 < k[0] && (k[0] -= 12),
                                  (k[0] = k[0].toString()),
                                  (k[0] =
                                    k[0].length < 2 ? "0".concat(k[0]) : k[0]),
                                  (n = " - " + k[0] + ":" + k[1])),
                                "1" == eddResultJson.show_edd_between_dates
                                  ? ((v = (o = [
                                      "Sunday",
                                      "Monday",
                                      "Tuesday",
                                      "Wednesday",
                                      "Thursday",
                                      "Friday",
                                      "Saturday",
                                    ])[new Date(j).getDay()]),
                                    (l = minDate.split("-")),
                                    (m =
                                      o[
                                        (_ = addDays(
                                          (l = new Date(l[0], l[1] - 1, l[2])),
                                          eddResultJson.max_delivery_days
                                        )).getDay()
                                      ]),
                                    (u = (_ = dateObjToString(_)).split("-")),
                                    v +
                                      ", " +
                                      w[2] +
                                      " " +
                                      daysArr[w[1] - 1] +
                                      " " +
                                      w[0] +
                                      " TO " +
                                      m +
                                      ", " +
                                      u[2] +
                                      " " +
                                      daysArr[u[1] - 1] +
                                      " " +
                                      u[0])
                                  : Q +
                                    ", " +
                                    w[2] +
                                    " " +
                                    daysArr[w[1] - 1] +
                                    " " +
                                    w[0] +
                                    n),
                          ]),
                          x &&
                            "" != x &&
                            (p = (y = x.includes(J[0])
                              ? x.replaceAll(J[0], c[0])
                              : x).includes(J[1])
                              ? y.replaceAll(J[1], c[1])
                              : y).includes(J[2]) &&
                            (p = p.replaceAll(J[2], c[2])),
                          "0" == eddResultJson.edd_display_position
                            ? (1 < g.length &&
                              "add-to-cart-form" ==
                                jQueryOTD(".form").attr("data-type")
                                ? jQueryOTD(".form")
                                : g
                              ).after('<div id="main_content">' + p + "</div>")
                            : "1" == eddResultJson.edd_display_position &&
                              (1 < g.length &&
                              "add-to-cart-form" ==
                                jQueryOTD(".form").attr("data-type")
                                ? jQueryOTD(".form")
                                : g
                              ).before(
                                '<div id="main_content">' + p + "</div>"
                              ),
                          eddResultJson.edd_datetime_margin &&
                            ((D = eddResultJson.edd_datetime_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_dateTime_class"
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_dateTime_class")
                                .css({
                                  margin:
                                    D.edd_datetime_margin_top +
                                    "px " +
                                    D.edd_datetime_margin_right +
                                    "px " +
                                    D.edd_datetime_margin_bottom +
                                    "px " +
                                    D.edd_datetime_margin_left +
                                    "px",
                                })),
                          eddResultJson.edd_timer_margin &&
                            ((f = eddResultJson.edd_timer_margin),
                            jQueryOTD("#main_content").find(
                              ".edd_timerDayHour_class"
                            ) &&
                              jQueryOTD("#main_content")
                                .find(".edd_timerDayHour_class")
                                .css({
                                  margin:
                                    f.edd_timer_margin_top +
                                    "px " +
                                    f.edd_timer_margin_right +
                                    "px " +
                                    f.edd_timer_margin_bottom +
                                    "px " +
                                    f.edd_timer_margin_left +
                                    "px",
                                })),
                          eddResultJson.edd_timer_appearance &&
                            ((h = eddResultJson.edd_timer_appearance),
                            jQueryOTD(".timer_digit").css({
                              "background-color": h.edd_timer_digit_bg_color,
                              color: h.edd_timer_digit_color,
                              "font-size": h.edd_timer_font_size + "px",
                            }),
                            jQueryOTD(".timer_label").css({
                              "font-size": h.edd_timer_label_font_size + "px",
                              "font-weight": h.edd_timer_label_font_weight,
                              color: h.edd_timer_units_label_color,
                            }),
                            jQueryOTD(".edd_timer_separator").css({
                              "font-size": h.edd_timer_font_size + "px",
                              color: h.edd_timer_separator_color,
                            }))),
                      -1 === Math.sign(t) &&
                        (estimated_delivery_date(), t < 0 && clearInterval(V)),
                      clearInterval(V);
                  }, 1e3)))
                : "2" == T &&
                  ((z = x),
                  (W =
                    void 0 !== (H = null != m ? m[0] : H)
                      ? Q +
                        ", " +
                        w[2] +
                        " " +
                        daysArr[w[1] - 1] +
                        " " +
                        w[0] +
                        " - " +
                        H
                      : ((W = eddResultJson.delivery_time),
                        Q +
                          ", " +
                          w[2] +
                          " " +
                          daysArr[w[1] - 1] +
                          " " +
                          w[0] +
                          " - " +
                          W[0])),
                  (z = z.replaceAll("{{date_time}}", W)),
                  "0" == eddResultJson.edd_display_position
                    ? g.after('<div id="main_content">' + z + "</div>")
                    : "1" == eddResultJson.edd_display_position &&
                      g.before('<div id="main_content">' + z + "</div>"),
                  jQueryOTD("#main_content")
                    .find(".edd_timerDayHour_class")
                    .hide(),
                  jQueryOTD("#main_content").find(".edd_dayHour_class").hide(),
                  jQueryOTD("#main_content")
                    .find(".edd_dateTime_class")
                    .addClass("edd_date_time_style"),
                  eddResultJson.edd_datetime_margin &&
                    ((z = eddResultJson.edd_datetime_margin),
                    jQueryOTD("#main_content").find(".edd_dateTime_class") &&
                      jQueryOTD("#main_content")
                        .find(".edd_dateTime_class")
                        .css({
                          "margin-bottom": z.edd_datetime_margin_bottom + "px",
                          "margin-left": z.edd_datetime_margin_left + "px",
                          "margin-right": z.edd_datetime_margin_right + "px",
                          "margin-top": z.edd_datetime_margin_top + "px",
                        })))));
      },
    }));
}
function date_change_onTimeDel_function_edd(e, t, a, r) {
  var d = r.hide_slots_settings;
  jQueryOTD(".iweb-dt-deliveryTime").addClass(
    "iweb_order_delivery_advance_loader loader"
  ),
    jQueryOTD(".iweb-dt-deliveryTime").attr("disabled", "true"),
    jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass("iweb-dt-isRequired"),
    jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
      "iweb-dt-isRequired"
    );
  var i = new Date(e),
    s = ("0" + i.getDate()).slice(-2),
    n = ("0" + (i.getMonth() + 1)).slice(-2),
    o = i.getFullYear(),
    e = s + "-" + n + "-" + o,
    l = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][i.getDay()],
    _ = dateFormatConvert("dd-mm-yy", t, "-", a, e),
    m = find_separator_date(r.date_format),
    u = dateFormatConvert(r.date_format, t, m, a, r.min_date),
    c = r.today_date;
  jQueryOTD(".iweb-dt-deliveryTime").children("option").remove();
  var y = '<option value="">' + r.select_time_text + "</option>",
    p = '<option value="">' + r.select_time_text + "</option>",
    D = r.cutoff_time,
    f = (D = D.split("."))[0],
    i = D[1],
    m = (c = c.split("-"))[0],
    D = c[1],
    c = c[2],
    h = dateFormatConvert("dd-mm-yy", t, "-", a, (h = c + "-" + D + "-" + m)),
    v = r.hr_24,
    g = r.min,
    T = r.padding_time_status,
    b = r.padding_time_min_days_status,
    O = r.padding_hour_24,
    j = r.padding_minute,
    w = r.min_day_value,
    m = !1;
  if (((tempObj = {}), void 0 === e)) console.log("Something wrong");
  else if (void 0 !== e && "0" == r.timer_status_format) {
    for (
      var Q = r.delivery_time.time,
        x = [],
        A = [],
        I = [],
        S = [],
        k = [],
        J = 0;
      J < Q.length;
      J++
    )
      (x[J] =
        '<option value="' +
        r.delivery_time.time_24[J] +
        '">' +
        r.delivery_time.time_24[J] +
        "</option>"),
        (A[J] = r.delivery_time.time_24[J]),
        (I[J] = r.delivery_time.time[J]);
    (1 == r.cutoff_time_status && _ == h) ||
    (1 == r.cutoff_time_status &&
      1 == r.cutoff_time_min_day &&
      _ == u &&
      0 != r.min_day_value)
      ? parseInt(f) < parseInt(v) ||
        (parseInt(f) == parseInt(v) && parseInt(i) < parseInt(g))
        ? (m = !0)
        : jQueryOTD.each(Q, function (e, t) {
            var a, r, i;
            _ == h || _ == u
              ? ((start_time = t.split(":")),
                (r = 60 * start_time[0]),
                (i = start_time[1]),
                (a = parseInt(r) + parseInt(i)),
                (t = 60 * O + j),
                1 == d
                  ? ((r = start_time[0]),
                    (i = start_time[1]),
                    1 == T && 0 == b && 0 != w
                      ? (v < r || (v == r && g < i)) &&
                        ((y += x[e]), (S[e] = A[e]), (k[e] = I[e]))
                      : 1 == T &&
                        t <= a &&
                        ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])),
                    0 == T &&
                      (v < r || (v == r && g < i)) &&
                      ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])))
                  : ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])))
              : ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])),
              y.length;
          })
      : jQueryOTD.each(Q, function (e, t) {
          var a, r, i;
          _ == h || _ == u
            ? ((start_time = t.split(":")),
              (r = 60 * start_time[0]),
              (i = start_time[1]),
              (a = parseInt(r) + parseInt(i)),
              (t = 60 * O + j),
              1 == d
                ? ((r = start_time[0]),
                  (i = start_time[1]),
                  1 == T && 0 == b && 0 != w
                    ? (v < r || (v == r && g < i)) &&
                      ((y += x[e]), (S[e] = A[e]), (k[e] = I[e]))
                    : 1 == T &&
                      t <= a &&
                      ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])),
                  0 == T &&
                    (v < r || (v == r && g < i)) &&
                    ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])))
                : ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])))
            : ((y += x[e]), (S[e] = A[e]), (k[e] = I[e])),
            y.length;
        });
  } else if (void 0 !== e && "1" == r.timer_status_format) {
    ((1 == r.cutoff_time_status && _ == h) ||
      (1 == r.cutoff_time_status &&
        1 == r.cutoff_time_min_day &&
        _ == u &&
        0 != r.min_day_value)) &&
      ((1 == r.cutoff_time_status && parseInt(f) < parseInt(v)) ||
        (1 == r.cutoff_time_status &&
          parseInt(f) == parseInt(v) &&
          parseInt(i) < parseInt(g))) &&
      (m = !0);
    var R = [],
      F = "",
      L = 0;
    0 != r.order_data &&
      jQueryOTD.each(r.order_data, function (e, t) {
        var a = t.delivery_date,
          r = (a = a.split("-"))[0],
          i = a[1],
          a = a[2];
        r == o &&
          i == n &&
          a == s &&
          "" != t.delivery_time &&
          (F.replace(/\s/g, "") !== t.delivery_time.replace(/\s/g, "")
            ? ((F = t.delivery_time),
              ((a = []).count = 1),
              "12" == t.time_format_hour
                ? find_separator_time(t.delivery_time, "12")
                : find_separator_time(t.delivery_time, "24"),
              (a.time_slot = t.delivery_time),
              void 0 !== a.time_slot &&
                ((a.start_time = a.time_slot.split("-")[0]),
                (a.end_time = a.time_slot.split("-")[1]),
                R.push(a),
                L++))
            : 0 != L && (R[L - 1].count = R[L - 1].count + 1));
      });
    for (
      var C = r.delivery_time,
        N = [],
        M = [],
        P = [],
        E = [],
        q = [],
        V = [],
        $ = [],
        J = 0;
      J < C[l].start_time.length;
      J++
    ) {
      var H = C[l].start_time[J] + "-" + C[l].end_time[J],
        W = C[l].start_time[J] + "-" + C[l].end_time[J],
        z = { pre: C[l].pre_message[J], post: C[l].post_message[J] },
        U = "" != C[l].limit[J] ? parseInt(C[l].limit[J]) : 0,
        B = "" != C[l].totalorder[J] ? parseInt(C[l].totalorder[J]) : 0;
      0 < R.length
        ? jQueryOTD.each(R, function (e, t) {
            1 == U && 0 < B
              ? ((H = H.replace(/\s/g, "")),
                (W = W.replace(/\s/g, "")),
                (t.time_slot = t.time_slot.replace(/\s/g, "")),
                0 != C[l].start_time[J].localeCompare(t.start_time) ||
                0 != C[l].end_time[J].localeCompare(t.end_time) ||
                B > parseInt(t.count)
                  ? -1 == N.indexOf(H) && (N.push(H), M.push(W), P.push(z))
                  : -1 == V.indexOf(H) && (V.push(H), $.push(z)))
              : 0 == U &&
                -1 == N.indexOf(H) &&
                (N.push(H), M.push(W), P.push(z));
          })
        : ((1 == U && 0 < B) || 0 == U) &&
          -1 == N.indexOf(H) &&
          (N.push(H), M.push(W), P.push(z));
    }
    (_ != h && _ != u) ||
      jQueryOTD.each(N, function (e, t) {
        s =
          "12" == t.time_display_format
            ? find_separator_time(t, "12")
            : find_separator_time(t, "24");
        var a = t.split(s)[0],
          r = (a = a.split(":"))[0],
          i = a[1],
          a = (a = t.split(s)[0]).split(":"),
          s = 60 * parseInt(a[0]) + parseInt(a[1]),
          a = 60 * parseInt(O) + parseInt(j);
        1 == d &&
          (1 == T && 0 == b && 0 != w
            ? (r <= v || v == r) &&
              i < g &&
              -1 == V.indexOf(t) &&
              (V.push(t), $.push(P[e]))
            : 1 == T &&
              s <= a &&
              ((_ != h && _ != u) ||
                (-1 == V.indexOf(t) && (V.push(t), $.push(P[e]))),
              _ == u &&
                1 == b &&
                0 != w &&
                -1 == V.indexOf(t) &&
                (V.push(t), $.push(P[e]))),
          0 == T &&
            (r <= v || v == r) &&
            i < g &&
            -1 == V.indexOf(t) &&
            (V.push(t), $.push(P[e])));
      });
    m = !1;
    ((1 == r.cutoff_time_status && _ == h) ||
      (1 == r.cutoff_time_status &&
        1 == r.cutoff_time_min_day &&
        _ == u &&
        0 != r.min_day_value)) &&
      (parseInt(f) < parseInt(v) ||
        (parseInt(f) == parseInt(v) && parseInt(i) < parseInt(g))) &&
      (m = !0);
    var Y = [],
      G = [];
    m
      ? 0
      : (0 < V.length
          ? jQuery.grep(N, function (e, t) {
              -1 == jQuery.inArray(e, V) &&
                (E.push(e), q.push(M[t]), Y.push(P[t].pre), G.push(P[t].post));
            })
          : jQueryOTD.each(N, function (e, t) {
              E.push(t), q.push(M[e]), Y.push(P[e].pre), G.push(P[e].post);
            }),
        E.sort(),
        (k = E));
  } else
    void 0 !== e && "2" == r.timer_status_format
      ? (1 == r.cutoff_time_status && _ == h) ||
        (1 == r.cutoff_time_status &&
          1 == r.cutoff_time_min_day &&
          _ == u &&
          0 != r.min_day_value)
        ? (1 == r.cutoff_time_status && parseInt(f) < parseInt(v)) ||
          (1 == r.cutoff_time_status &&
            parseInt(f) == parseInt(v) &&
            (parseInt(i), parseInt(g)))
        : ((e = r.delivery_time), (tempObj = e))
      : ((1 == r.cutoff_time_status && _ == h) ||
          (1 == r.cutoff_time_status &&
            1 == r.cutoff_time_min_day &&
            _ == u &&
            0 != r.min_day_value)) &&
        ((1 == r.cutoff_time_status && parseInt(f) < parseInt(v)) ||
          (1 == r.cutoff_time_status &&
            parseInt(f) == parseInt(v) &&
            (parseInt(i), parseInt(g))));
  return (
    "2" != r.timer_status_format &&
      void 0 !== k &&
      ((tempObj_12 = {}),
      (tempObj_24 = {}),
      Object.keys(k).forEach((e, t) => {
        null != S && S[e] && (tempObj_12[t] = S[e]),
          k[e] && (tempObj_24[t] = k[e]);
      }),
      (tempObj = { tempObj_12: tempObj_12, tempObj_24: tempObj_24 })),
    tempObj
  );
}
function addOneDay(e, t, a, r) {
  return (e =
    "object" ==
    typeof (e = recursiveOnDisableDays(
      (e = recursiveOnDisableDates((e = addDays(e, t)), a)),
      r
    ))
      ? formatDate(e)
      : e);
}
function formatDate(e) {
  var t = new Date(e),
    a = "" + (t.getMonth() + 1),
    e = "" + t.getDate();
  return [
    t.getFullYear(),
    (a = a.length < 2 ? "0" + a : a),
    (e = e.length < 2 ? "0" + e : e),
  ].join("-");
}
function edd_orderLimit(i, e, t, s) {
  var a = e,
    d = [],
    r = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ],
    e = new Date(i).getDay(),
    n = a[(r = daysArray[e])].start_time,
    o = a[r].end_time,
    l = a[r].to_message,
    _ = a[r].limit,
    m = a[r].totalorder,
    u = n.indexOf(t[0]),
    c = [],
    y = [],
    p = [],
    D = [],
    f = [];
  jQueryOTD.each(n, function (e, t) {
    u <= e &&
      (c.push(n[e]), y.push(o[e]), p.push(l[e]), D.push(_[e]), f.push(m[e]));
  }),
    0 < t.length &&
      jQueryOTD.each(t, function (e, t) {
        e = {
          startTime: c[e],
          endTime: y[e],
          toMessage: p[e],
          limitStatus: D[e],
          totalOrders: f[e],
          createdDeliveryTime: c[e] + "-" + y[e],
        };
        d.push(e);
      });
  for (var h = d.length - 1; 0 <= h; h--)
    "1" == d[h].limitStatus && "0" == d[h].totalOrders && d.splice(h, 1);
  var v = [];
  if (
    (jQueryOTD.each(d, function (e, t) {
      for (var a = s.length - 1; 0 <= a; a--) {
        var r = s[a];
        d[e].createdDeliveryTime == r.delivery_time &&
          i == r.delivery_date &&
          "" !== r.total_orders &&
          "" !== d[e].totalOrders &&
          parseInt(r.total_orders) >= parseInt(d[e].totalOrders) &&
          v.push(e);
      }
    }),
    0 < v.length)
  )
    for (h = v.length - 1; 0 <= h; h--) d.splice(h, 1);
  var g = [],
    T = [];
  return (
    jQueryOTD.each(d, function (e, t) {
      g.push(d[e].startTime), T.push(d[e].endTime);
    }),
    { startTime: g, endTime: T }
  );
}
function addDays(e, t) {
  e = new Date(e);
  return e.setDate(e.getDate() + parseInt(t)), e;
}
function recursiveOnDisableDates(e, t) {
  if (t.includes(e)) {
    var a = addDays(e, 1),
      r = a.getDate();
    r = (r = r.toString()).length < 2 ? "0".concat(r) : r;
    var i = (i = (a.getMonth() + 1).toString()).length < 2 ? "0".concat(i) : i;
    return recursiveOnDisableDates(
      (e = a.getFullYear() + "-" + i + "-" + r),
      t
    );
  }
  return e;
}
function recursiveOnDisableDays(e, t, a) {
  var r = e,
    i = t,
    e = a,
    a = new Date(r).getDay();
  if (i.includes(a.toString())) {
    (i = (i = (r = addDays(r, 1)).getDate()).length < 2 ? "0".concat(i) : i),
      (a = (a = (r.getMonth() + 1).toString()).length < 2 ? "0".concat(a) : a),
      (i = r.getFullYear() + "-" + a + "-" + i),
      recursiveOnDisableDates(i, e);
    return recursiveOnDisableDays(i, t, e);
  }
  return r;
}
function recursiveOnDeliveryTime_cutoff_zero(e, t, a) {
  var r = [];
  return (r = "cutoff" == a ? (t[0] > e ? "" : t) : r);
}
function recursiveOnDeliveryTime_cutoff_one(e, t, a) {
  var r = [];
  return (r = "cutoff" == a ? (e < t[0] ? "" : t) : r);
}
function dateObjToString(e) {
  var t = e.getDate(),
    a = e.getMonth() + 1,
    t = t.toString(),
    a = a.toString();
  return (
    (t = t.length < 2 ? "0".concat(t) : t),
    (a = a.length < 2 ? "0".concat(a) : a),
    e.getFullYear() + "-" + a + "-" + t
  );
}
function dateObjToTimeString(e) {
  var t = e.getHours(),
    e = e.getMinutes();
  return (
    (t = (t = t.toString()).length < 2 ? "0".concat(t) : t) +
    ":" +
    (e = (e = e.toString()).length < 2 ? "0".concat(e) : e)
  );
}
function change_time_12to24(e, t) {
  var a = (e = e.replace(/\s/g, "")).split(t),
    r = a[0],
    i = a[1];
  if (
    ((r = r.replace(/\s/g, "")),
    (i = i.replace(/\s/g, "")),
    1 < r.length &&
      "" != r &&
      "" != i &&
      (null != r.match("(AM)") || null != r.match("(PM)")))
  ) {
    var s = Number(r.match(/^(\d+)/)[1]),
      d = Number(r.match(/:(\d+)/)[1]);
    null != r.match("(AM)")
      ? "AM" == r.match("(AM)")[1].toUpperCase() && 12 == s && (s -= 12)
      : null != r.match("(PM)") &&
        "PM" == r.match("(PM)")[1].toUpperCase() &&
        s < 12 &&
        (s += 12);
    (e = s.toString()),
      (a = d.toString()),
      (r = (e = s < 10 ? "0" + e : e) + ":" + (a = d < 10 ? "0" + a : a)),
      (i = i.replace(/\s/g, "")),
      (s = Number(i.match(/^(\d+)/)[1])),
      (d = Number(i.match(/:(\d+)/)[1]));
    null != i.match("(AM)")
      ? "AM" == i.match("(AM)")[1].toUpperCase() && 12 == s && (s -= 12)
      : null != i.match("(PM)") &&
        "PM" == i.match("(PM)")[1].toUpperCase() &&
        s < 12 &&
        (s += 12);
    (e = s.toString()), (a = d.toString());
    return (
      r +
      t +
      (i = (e = s < 10 ? "0" + e : e) + ":" + (a = d < 10 ? "0" + a : a))
    );
  }
}
function find_separator_time(e, t) {
  var a;
  return (
    (e = e.replace(/\s/g, "")),
    (t = "24" == t ? e.length - (a = 5) : e.length - (a = 7)),
    e.substring(a, t)
  );
}
function convert_time_24to12(e, t = 0) {
  var a = e.length - 5,
    r = e.substring(5, a),
    i = e.split(r),
    s = i[0],
    a = i[1],
    e = +s.substr(0, 2),
    i = e < 12 ? " AM" : " PM",
    s = ("0" + (e % 12 || 12)).slice(-2) + s.substr(2, 3) + i,
    e = +a.substr(0, 2),
    i = e < 12 ? " AM" : " PM",
    i =
      s +
      " " +
      r +
      " " +
      (a = ("0" + (e % 12 || 12)).slice(-2) + a.substr(2, 3) + i);
  return (i = t ? s.replace(" ", "") + "" + r + a.replace(" ", "") : i);
}
function find_separator_date(e) {
  var t = e.substring(2, 3);
  return "/" == t ||
    "-" == t ||
    "." == t ||
    "/" == (t = e.substring(4, 5)) ||
    "-" == t ||
    "." == t
    ? t
    : void console.log("something wrong in date separator find");
}
function check_validation(e, t, a, r, i) {
  jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    "NULL" != i.timer_status_format
      ? jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()
        ? 0 < jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").length &&
          !jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()
          ? "vaporetto-pizza.myshopify.com" == shopName
            ? (jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
                "iweb-dt-isRequired"
              ),
              jQueryOTD(".iweb-dt-deliveryRequired").hide(),
              t.unbind("submit"))
            : ("araya-chocolate.myshopify.com" == shopName
                ? jQueryOTD("html, body").animate(
                    {
                      scrollTop:
                        jQueryOTD(".iw-order-delivery-dt-calendar").offset()
                          .top - 500,
                    },
                    1e3
                  )
                : document
                    .querySelectorAll(".iw-order-delivery-dt-calendar")
                    .forEach((e) =>
                      e.scrollIntoView({ behavior: "smooth", block: "center" })
                    ),
              jQueryOTD(".iweb-dt-deliveryRequired").html(r).show(),
              jQueryOTD(".iweb-dt-deliveryTime").addClass("iweb-dt-isRequired"),
              setTimeout(function () {
                t.find("[name='checkout']").removeClass("btn--loading");
              }, 0),
              e.preventDefault(),
              e.stopImmediatePropagation())
          : ("undefined" != typeof BOLD &&
              void 0 !== BOLD.recurring_orders &&
              void 0 !== BOLD.recurring_orders.app &&
              void 0 !== BOLD.recurring_orders.app.cartWidget &&
              (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !0),
            jQueryOTD(".iweb-dt-deliveryTime").removeClass(
              "iweb-dt-isRequired"
            ),
            jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
              "iweb-dt-isRequired"
            ),
            jQueryOTD(".iweb-dt-deliveryRequired").hide(),
            t.unbind("submit"),
            t.find("[name='checkout']").length
              ? (t.find("[name='checkout']").unbind("click"),
                t.find("[name='checkout']").click())
              : "appi-earth.myshopify.com" != shopName && t.submit(),
            "liliyum-patisserie-cafe.myshopify.com" == shopName &&
              (e.preventDefault(),
              e.stopImmediatePropagation(),
              window.stop(),
              (window.location.href = "/checkout")))
        : ("araya-chocolate.myshopify.com" == shopName
            ? jQueryOTD("html, body").animate(
                {
                  scrollTop:
                    jQueryOTD(".iw-order-delivery-dt-calendar").offset().top -
                    500,
                },
                1e3
              )
            : document
                .querySelectorAll(".iw-order-delivery-dt-calendar")
                .forEach((e) =>
                  e.scrollIntoView({ behavior: "smooth", block: "center" })
                ),
          jQueryOTD(".iweb-dt-deliveryRequired")
            .html(a)
            .attr("style", "display:block"),
          jQueryOTD(".iw-order-delivery-dt-calendar").addClass(
            "iweb-dt-isRequired"
          ),
          setTimeout(function () {
            t.find("[name='checkout']").removeClass("btn--loading");
          }, 0),
          e.preventDefault(),
          e.stopImmediatePropagation())
      : jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()
      ? ("undefined" != typeof BOLD &&
          void 0 !== BOLD.recurring_orders &&
          void 0 !== BOLD.recurring_orders.app &&
          void 0 !== BOLD.recurring_orders.app.cartWidget &&
          (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !0),
        jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
          "iweb-dt-isRequired"
        ),
        jQueryOTD(".iweb-dt-deliveryRequired").hide(),
        t.unbind("submit"),
        jQueryOTD('a[href="/checkout"]').length &&
          jQueryOTD('a[href="/checkout"]').unbind("click"),
        t.find("[name='checkout']").length
          ? (t.find("[name='checkout']").unbind("click"),
            t.find("[name='checkout']").click())
          : t.submit())
      : ("araya-chocolate.myshopify.com" == shopName
          ? jQueryOTD("html, body").animate(
              {
                scrollTop:
                  jQueryOTD(".iw-order-delivery-dt-calendar").offset().top -
                  500,
              },
              1e3
            )
          : document
              .querySelectorAll(".iw-order-delivery-dt-calendar")
              .forEach((e) =>
                e.scrollIntoView({ behavior: "smooth", block: "center" })
              ),
        jQueryOTD(".iweb-dt-deliveryRequired").html(a).show(),
        jQueryOTD(".iw-order-delivery-dt-calendar").addClass(
          "iweb-dt-isRequired"
        ),
        setTimeout(function () {
          t.find("[name='checkout']").removeClass("btn--loading");
        }, 0),
        e.preventDefault(),
        e.stopImmediatePropagation());
}
function dateFormatConvert(e, t, a, r, i, s) {
  var d = e.toLowerCase().split(a),
    n = t.toLowerCase().split(r);
  if ("loop" == s) {
    var o = [];
    return (
      jQueryOTD.each(i, function (e, t) {
        t = t.split(a);
        (t[d[0]] = t[0]),
          (t[d[1]] = t[1]),
          (t[d[2]] = t[2]),
          o.push(t[n[0]] + r + t[n[1]] + r + t[n[2]]);
      }),
      o
    );
  }
  (o = ""), (i = i.split(a));
  return (
    (i[d[0]] = i[0]),
    (i[d[1]] = i[1]),
    (i[d[2]] = i[2]),
    (o = i[n[0]] + r + i[n[1]] + r + i[n[2]])
  );
}
function oddt_invalid_days(e) {
  var t = e && e.split(",");
  if (t.length) for (var a = 0; a < t.length; a++) t[a] = parseInt(t[a]);
  else t = [];
  return t;
}
function oddt_disable_dates(e) {
  var t = !1;
  return (t = e ? e.split(",") : t);
}
function oddt_day_text_value(e) {
  e = parseDate(e);
  return [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ][new Date(e).getDay()];
}
function oddt_month_text_value(e) {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ][new Date(e).getMonth()];
}
function parseDate(e) {
  var t = Date.parse(e);
  return isNaN(t)
    ? Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "))
    : t;
}
function oddt_cutOffTimeDate(e, t, a, r) {
  var i = 0,
    s = t,
    d = e.currentmonthday,
    n = r,
    o = e.currentHr,
    l = e.cutoff_time_status,
    r = e.cutoff_hour_minute;
  a = parseDate(a);
  (e = new Date(a).getDate()), (a = oddt_month_text_value(a));
  return (i =
    0 == l ||
    t != s ||
    parseInt(d) != parseInt(e) ||
    n != a ||
    parseFloat(o) <= parseFloat(r)
      ? 1
      : i);
}
function oddt_get_time_slots(e, t, a, r) {
  var i = e,
    e = i.time_format;
  return 0 == e
    ? oddt_time_dropdown_format_zero(i, t, a, r)
    : 1 == e
    ? oddt_time_dropdown_format_three(i, t, a, r)
    : 2 == e
    ? oddt_time_dropdown_format_one(i, t, a, r)
    : void 0;
}
function hide_slots_settings(e, t) {
  return 1 == e.hide_slots_settings ||
    1 == e.padding_time_status ||
    (1 == e.cutoff_time_status && e.currentHr >= e.cutoff_hour_minute)
    ? t
    : 0;
}
function shipping_calender_show(e, t, a) {
  if (0 < e && 0 < t && e <= t)
    return (
      jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
      jQueryOTD(".main_loader").after(
        '<div class="appsonrent-dds-main"><p class="appsonrent-dds-deliveryRequired" style="display:block">Delivery date selection is not available for cart.</p></div>'
      ),
      !0
    );
  auto_minday_calculation(
    (oddShippingCalander = resultJson).auto_date,
    resultJson,
    oddt_invalid_days(resultJson.invalid_day),
    resultJson.date_format,
    oddt_disable_dates(resultJson.extra_no_available),
    "otd_shipping"
  ),
    shipping_show(resultJson, a);
}
function convertFixDate(t, a) {
  if (t) {
    let e = t;
    var r = -1 < t.indexOf("/") ? t.split("/") : t.split("-");
    return (
      "dd/mm/yy" === a || "dd-mm-yy" === a
        ? (e = `${r[1]}/${r[0]}/${r[2]}`)
        : "dd/yy/mm" === a || "dd-yy-mm" === a
        ? (e = `${r[2]}/${r[0]}/${r[1]}`)
        : "mm/yy/dd" === a || "mm-yy-dd" === a
        ? (e = `${r[0]}/${r[2]}/${r[1]}`)
        : "yy/dd/mm" === a || "yy-dd-mm" === a
        ? (e = `${r[2]}/${r[1]}/${r[0]}`)
        : "mm/dd/yy" === a || "mm-dd-yy" === a
        ? (e = `${r[0]}/${r[1]}/${r[2]}`)
        : ("yy-mm-dd" !== a && "yy/mm/dd" !== a) ||
          (e = `${r[1]}/${r[2]}/${r[0]}`),
      new Date(e)
    );
  }
  return new Date(t);
}
function date_change_onTimeDel_function(n, e, t) {
  var o = n.min_date,
    a = n.date_format,
    i = !0,
    l = n.hide_slots_settings;
  jQueryOTD(".iweb-dt-deliveryTime").addClass(
    "iweb_order_delivery_advance_loader loader"
  ),
    jQueryOTD(".iweb-dt-deliveryTime").attr("disabled", "true"),
    jQueryOTD(".iweb-dt-deliveryRequired").hide(),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass("iweb-dt-isRequired"),
    jQueryOTD(".iw-order-delivery-dt-calendar").removeClass(
      "iweb-dt-isRequired"
    ),
    (e = convertFixDate(e, "mm-dd-yy"));
  var r = new Date(e),
    d = ("0" + r.getDate()).slice(-2),
    _ = ("0" + (r.getMonth() + 1)).slice(-2),
    m = r.getFullYear(),
    e = d + "-" + _ + "-" + m,
    s = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][r.getDay()],
    u = find_separator_date(a),
    c = dateFormatConvert("dd-mm-yy", a, "-", u, e),
    y = formatDate(n.today_date.date),
    p = r.getDay();
  jQueryOTD(".iweb-dt-deliveryTime").children("option").remove();
  var D = '<option value="">' + n.select_time_text + "</option>",
    f = '<option value="">' + n.select_time_text + "</option>",
    h = n.cutoff_hour,
    v = n.cutoff_minute,
    g = (y = y.split("-"))[0],
    r = y[1],
    y = y[2],
    T = dateFormatConvert("dd-mm-yy", a, "-", u, (T = y + "-" + r + "-" + g)),
    b = (n.hr, n.hr_24),
    O = n.min,
    j = n.padding_time_status,
    w = n.padding_time_min_status,
    Q = n.padding_hour_24,
    x = n.padding_minute,
    A = n.min_day_value,
    g = !1;
  if (void 0 === e) console.log("Something wrong");
  else if (void 0 !== e && "0" == n.timer_status_format) {
    for (
      var I = n.delivery_time.time.split(","), S = [], k = 0;
      k < I.length;
      k++
    )
      S[k] =
        '<option value="' +
        n.delivery_time.time_24[k] +
        '">' +
        n.delivery_time.time_24[k] +
        "</option>";
    (1 == n.cutoff_time_status && c == T) ||
    (1 == n.cutoff_time_status &&
      1 == n.cutoff_time_min_day &&
      c == o &&
      0 != n.min_day_value)
      ? parseInt(h) < parseInt(b) ||
        (parseInt(h) == parseInt(b) && parseInt(v) < parseInt(O))
        ? (i = !(g = !0))
        : jQueryOTD.each(I, function (e, t) {
            var a, r;
            c == T || c == o
              ? ((start_time = t.split(":")),
                (a = 60 * start_time[0]),
                (r = start_time[1]),
                (t = parseInt(a) + parseInt(r)),
                1 == l
                  ? ((a = start_time[0]),
                    (r = start_time[1]),
                    1 == j && 0 == w && 0 != A
                      ? (b < a || (b == a && O < r)) && (D += S[e])
                      : 1 == j && 60 * Q + x <= t && (D += S[e]),
                    0 == j &&
                      (b < a || (b == a && O < r)) &&
                      ((i = !0), (D += S[e])))
                  : (D += S[e]))
              : (D += S[e]),
              (i = D.length !== f.length);
          })
      : jQueryOTD.each(I, function (e, t) {
          var a, r;
          c == T || c == o
            ? ((start_time = t.split(":")),
              (a = 60 * start_time[0]),
              (r = start_time[1]),
              (t = parseInt(a) + parseInt(r)),
              1 == l
                ? ((a = start_time[0]),
                  (r = start_time[1]),
                  1 == j && 0 == w && 0 != A
                    ? (b < a || (b == a && O < r)) && (D += S[e])
                    : 1 == j && 60 * Q + x <= t && (D += S[e]),
                  0 == j &&
                    (b < a || (b == a && O < r)) &&
                    ((i = !0), (D += S[e])))
                : (D += S[e]))
            : (D += S[e]),
            (i = D.length !== f.length);
        });
  } else if (void 0 !== e && "1" == n.timer_status_format) {
    ((1 == n.cutoff_time_status && c == T) ||
      (1 == n.cutoff_time_status &&
        1 == n.cutoff_time_min_day &&
        c == o &&
        0 != n.min_day_value)) &&
      ((1 == n.cutoff_time_status && parseInt(h) < parseInt(b)) ||
        (1 == n.cutoff_time_status &&
          parseInt(h) == parseInt(b) &&
          parseInt(v) < parseInt(O))) &&
      (i = !(g = !0));
    var J = [],
      R = "",
      F = 0;
    0 != n.order_data &&
      jQueryOTD.each(n.order_data, function (e, t) {
        var a,
          r = t.delivery_date,
          i = (r = r.split("-"))[0],
          s = r[1],
          r = r[2];
        i == m &&
          s == _ &&
          r == d &&
          "" != t.delivery_time &&
          (R.replace(/\s/g, "") !== t.delivery_time.replace(/\s/g, "")
            ? ((R = t.delivery_time),
              ((r = []).count = 1),
              "12" == t.time_format_hour
                ? ((a = find_separator_time(t.delivery_time, "12")),
                  (r.time_slot = change_time_12to24(t.delivery_time, a)))
                : ((a = find_separator_time(t.delivery_time, "24")),
                  (r.time_slot = t.delivery_time)),
              void 0 !== r.time_slot &&
                ((r.start_time = r.time_slot.split(a)[0]),
                (r.end_time = r.time_slot.split(a)[1]),
                J.push(r),
                F++))
            : 0 != F && (J[F - 1].count = J[F - 1].count + 1));
      });
    for (
      var L = n.time_format_value,
        C = [],
        N = [],
        M = [],
        P = [],
        E = [],
        q = [],
        V = [],
        k = 0;
      k < L[s].start_time.length;
      k++
    ) {
      var $ =
          L[s].start_time[k] +
          " " +
          L[s].to_message[k] +
          " " +
          L[s].end_time[k],
        H = L[s].start_time[k] + "-" + L[s].end_time[k],
        W = "12" == n.time_display_format ? convert_time_24to12(H, 1) : H,
        z = { pre: L[s].pre_message[k], post: L[s].post_message[k] },
        U = "" != L[s].limit[k] ? parseInt(L[s].limit[k]) : 0,
        B = "" != L[s].totalorder[k] ? parseInt(L[s].totalorder[k]) : 0;
      0 < J.length
        ? jQueryOTD.each(J, function (e, t) {
            1 == U && 0 < B
              ? (($ = $.replace(/\s/g, "")),
                (W = W.replace(/\s/g, "")),
                (t.time_slot = t.time_slot.replace(/\s/g, "")),
                0 != L[s].start_time[k].localeCompare(t.start_time) ||
                0 != L[s].end_time[k].localeCompare(t.end_time) ||
                B > parseInt(t.count)
                  ? -1 == C.indexOf($) && (C.push($), N.push(W), M.push(z))
                  : -1 == q.indexOf($) && (q.push($), V.push(z)))
              : 0 == U &&
                -1 == C.indexOf($) &&
                (C.push($), N.push(W), M.push(z));
          })
        : ((1 == U && 0 < B) || 0 == U) &&
          -1 == C.indexOf($) &&
          (C.push($), N.push(W), M.push(z));
    }
    (c != T && c != o) ||
      jQueryOTD.each(C, function (e, t) {
        d =
          "12" == t.time_display_format
            ? find_separator_time(t, "12")
            : find_separator_time(t, "24");
        var a = t.split(d)[0],
          r = t.split(d)[0],
          i = (a = a.split(":"))[0],
          s = a[1],
          a = (a = t.split(d)[0]).split(":"),
          d = 60 * parseInt(a[0]) + parseInt(a[1]),
          a = 60 * parseInt(Q) + parseInt(x);
        1 == l &&
          (1 == j && 0 == w && 0 != A
            ? (i <= b || b == i) &&
              s < O &&
              -1 == q.indexOf(t) &&
              (q.push(t), V.push(M[e]))
            : 1 == j &&
              d <= a &&
              ((c != T && c != o) ||
                (-1 == q.indexOf(t) && (q.push(t), V.push(M[e]))),
              c == o &&
                1 == w &&
                0 != A &&
                -1 == q.indexOf(t) &&
                (q.push(t), V.push(M[e]))),
          0 == j &&
            (i <= b || b == i) &&
            n.current_time_c > r &&
            -1 == q.indexOf(t) &&
            (q.push(t), V.push(M[e])));
      });
    g = !1;
    ((1 == n.cutoff_time_status && c == T) ||
      (1 == n.cutoff_time_status &&
        1 == n.cutoff_time_min_day &&
        c == o &&
        0 != n.min_day_value)) &&
      (parseInt(h) < parseInt(b) ||
        (parseInt(h) == parseInt(b) && parseInt(v) < parseInt(O))) &&
      (g = !0);
    var Y = [],
      G = [];
    g
      ? (i = !1)
      : (0 < q.length
          ? jQuery.grep(C, function (e, t) {
              -1 == jQuery.inArray(e, q) &&
                (P.push(e), E.push(N[t]), Y.push(M[t].pre), G.push(M[t].post));
            })
          : jQueryOTD.each(C, function (e, t) {
              P.push(t), E.push(N[e]), Y.push(M[e].pre), G.push(M[e].post);
            }),
        0 < P.length
          ? jQueryOTD.each(P, function (e, t) {
              (t = "12" == n.time_display_format ? convert_time_24to12(t) : t),
                (D +=
                  '<option value="' +
                  E[e] +
                  '">' +
                  Y[e] +
                  " " +
                  t +
                  " " +
                  G[e] +
                  "</option>");
            })
          : (i = !1));
  } else if (void 0 !== e && "2" == n.timer_status_format) {
    g = !1;
    if (
      (g =
        ((1 == n.cutoff_time_status && c == T) ||
          (1 == n.cutoff_time_status &&
            1 == n.cutoff_time_min_day &&
            c == o &&
            0 != n.min_day_value)) &&
        (parseInt(h) < parseInt(b) ||
          (parseInt(h) == parseInt(b) && parseInt(v) < parseInt(O)))
          ? !0
          : g)
    )
      i = !1;
    else {
      for (var X = n.delivery_time.split(","), K = "", k = 0; k < X.length; k++)
        K += '<option value="' + X[k] + '">' + X[k] + "</option>";
      i = (D += K).length !== f.length;
    }
  } else
    ((1 == n.cutoff_time_status && c == T) ||
      (1 == n.cutoff_time_status &&
        1 == n.cutoff_time_min_day &&
        c == o &&
        0 != n.min_day_value)) &&
      (i = !(
        (1 == n.cutoff_time_status && parseInt(h) < parseInt(b)) ||
        (1 == n.cutoff_time_status &&
          parseInt(h) == parseInt(b) &&
          parseInt(v) < parseInt(O))
      ));
  if (
    (jQueryOTD(".iweb-dt-deliveryTime").removeAttr("disabled"),
    jQueryOTD(".iweb-dt-deliveryTime").removeClass(
      "iweb_order_delivery_advance_loader loader"
    ),
    "changeDate" == t)
  ) {
    c =
      "dd.mm.yy" == n.convert_date_format
        ? c.replace(/[/,\s]/g, ".").replace(/[-,\s]/g, ".")
        : c;
    jQueryOTD(".iw-order-delivery-dt-deliveryDayVal").val(
      [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ][p]
    ),
      jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val(c),
      jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val(""),
      0 == i &&
        ((p =
          "undefined" !== (p = n.required_message_order_limit) && "" != p
            ? p
            : "Sorry... You can't order for selected date. Please select other date"),
        jQueryOTD(".iweb-dt-deliveryRequired").html(p).show()),
      jQueryOTD(".iweb-dt-deliveryTime").append(D);
  } else if ("default" == t)
    return (
      (D = '<option value="">' + n.select_time_text + "</option>"),
      jQueryOTD(".iweb-dt-deliveryTime").append(D),
      i
    );
}
function shipping_show(t, e) {
  var a, r, i, s, d, n, o, l, _, m, u, c, y;
  null != t.shipping_product_not_available
    ? (jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
      jQueryOTD(
        'form[action*="/cart"] [name="checkout"],form[action="/cart?locale=en"] [name="checkout"]'
      ).removeAttr("disabled"),
      jQueryOTD(".identixweb-order-delivery").remove(),
      jQueryOTD(".main_loader").after(
        '<div class="appsonrent-dds-main"><p class="appsonrent-dds-deliveryRequired" style="display:block">' +
          t.shipping_product_not_available +
          "</p></div>"
      ))
    : ((appsStatus = "1"),
      (required_delivery_date = t.required),
      (use_time_option = t.timer_status),
      (a = parseInt(t.week_start)),
      (r = t.date_format),
      (i = oddt_invalid_days(t.invalid_day)),
      (s = oddt_disable_dates(t.extra_no_available)),
      (d = t.time_format),
      (n = oddt_day_text_value(t.current_time_c)),
      (o = t.required_message_date),
      (l = t.required_message_time),
      (_ = jQueryOTD("form[action*='/cart'],form[action='/cart?locale=en']")),
      (m = t.current_month),
      "1" == t.required &&
        ("undefined" != typeof BOLD &&
          void 0 !== BOLD.recurring_orders &&
          void 0 !== BOLD.recurring_orders.app &&
          void 0 !== BOLD.recurring_orders.app.cartWidget &&
          (BOLD.recurring_orders.app.cartWidget.checkoutEnabled = !1),
        "tsm-aquatics.myshopify.com" == shopName ||
        "petitbowl.myshopify.com" == shopName ||
        "events-by-daniela.myshopify.com" == shopName ||
        "gutenmorgenvlbg.myshopify.com" == shopName ||
        "durian-gao.myshopify.com" == shopName ||
        "fresh-grinds-cafe.myshopify.com" == shopName ||
        "okaese.myshopify.com" == shopName ||
        "birchtree-at-home.myshopify.com" == shopName ||
        "yippiii.myshopify.com" == shopName
          ? (jQueryOTD("[name='checkout']").removeAttr("disabled"),
            jQueryOTD("[name='checkout']").length &&
              jQueryOTD("[name='checkout']").click(function (e) {
                check_validation(e, _, o, l, t);
              }))
          : jQueryOTD('a[href="/checkout"]').length
          ? jQueryOTD('a[href="/checkout"]').click(function (e) {
              check_validation(e, _, o, l, t);
            })
          : jQueryOTD(".additional-checkout-button").length
          ? jQueryOTD(".additional-checkout-button").click(function (e) {
              check_validation(e, _, o, l, t);
            })
          : jQueryOTD("[name='checkout']").length
          ? jQueryOTD("[name='checkout']").click(function (e) {
              check_validation(e, _, o, l, t);
            })
          : _.find("[name='checkout']").length &&
            _.find("[name='checkout']").click(function (e) {
              check_validation(e, _, o, l, t);
            })),
      "NULL" != t.timer_status && t.delivery_time
        ? ((c = u = ""),
          (c = oddt_day_text_value(t.auto_current_time_c)),
          (y = t.auto_current_time_c),
          e
            ? (u = date_change_onTimeDel_function(t, y, "default"))
            : ((u = oddt_get_time_slots(t, c, y, t.auto_current_month)),
              1 == d && "" == u[1] && (u = "")),
          !u && e && auto_minday_calculation(t.auto_date, t, i, r, s),
          "" != u ||
            e ||
            (1 == t.cutoff_time_min_day ||
              (1 == t.cutoff_time_status && t.min_day_value),
            auto_minday_calculation(t.auto_date, t, i, r, s),
            (s =
              s +
              "," +
              oddt_get_date_formated(
                new Date(t.current_time_c),
                t.date_format
              ))),
          oddt_delivery_time_change_action(t.delivery_time_text, e))
        : 0 == oddt_cutOffTimeDate(t, n, t.auto_current_time_c, m) &&
          (auto_minday_calculation(t.auto_date, t, i, r, s),
          (s =
            s +
            "," +
            oddt_get_date_formated(new Date(t.current_time_c), t.date_format))),
      1 == t.enable &&
        1 == t.shipping_status &&
        (jQueryOTD(".appsonrent-dds-main").remove(),
        jQueryOTD(".otd_container").html(t.shipping_html)),
      bindDatePicker(i, a, r, t.months_name, t.days_name, s, t.max_date, t, e));
}
function oddt_delivery_time_change_action(o, l) {
  jQueryOTD(document).on("change", ".iw-otd-deliveryTime", async function () {
    // spark.updateCart({customFields: [{"name": "delivery-date-time", value: jQueryOTD(".uiDeliveryDateVal").val() + ' ' + jQueryOTD(".uiDeliveryTimeVal").val()}]}, () => {console.log('done')})
    jQueryOTD(
      '.iw-otd-deliveryTime option[value="' + jQueryOTD(this).val() + '"]'
    ).attr("selected", "selected"),
      jQueryOTD(".uiDeliveryTimeVal").val(jQueryOTD(this).val());
    var e,
      t,
      a,
      r,
      i,
      s = jQueryOTD(this).val(),
      d = jQueryOTD(".uiDeliveryDateVal").val(),
      n = jQueryOTD(".uiDeliveryDayVal").val();
    "" != s &&
      ((i = "attributes[" + o + "]=" + s + "&update"),
      (e = jQueryOTD(".uiLocationOrderTypeVal").val()),
      (t = jQueryOTD(".uiLocationNameVal").val()),
      (a = jQueryOTD(".uiLocationAddressVal").val()),
      (r = jQueryOTD(".uiLocationIdVal").val()),
      (i =
        "Shipping" == e
          ? "attributes[" +
            resultJson.delivery_date_text +
            "]=" +
            d +
            "&attributes[" +
            resultJson.delivery_day_text +
            "]=" +
            n +
            "&attributes[" +
            resultJson.delivery_time_text +
            "]=" +
            s +
            "&attributes[Order Type]=" +
            (l ? "" : "Shipping") +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "Store Pickup" == e
          ? "attributes[" +
            resultJson.delivery_date_text +
            "]=" +
            d +
            "&attributes[" +
            resultJson.delivery_day_text +
            "]=" +
            n +
            "&attributes[" +
            resultJson.delivery_time_text +
            "]=" +
            s +
            "&attributes[Order Type]=Store Pickup&attributes[Location Id]=" +
            r +
            "&attributes[Location Name]=" +
            t +
            "&attributes[Location Address]=" +
            a +
            "&attributes[Postal Code]=&update"
          : "attributes[" +
            resultJson.delivery_date_text +
            "]=" +
            d +
            "&attributes[" +
            resultJson.delivery_day_text +
            "]=" +
            n +
            "&attributes[" +
            resultJson.delivery_time_text +
            "]=" +
            s),
      jQueryOTD.ajax({
        url: "/cart",
        async: !0,
        data: i,
        type: "POST",
        dataType: "text",
      }),
      (cartParsData = i)),
      "" == s &&
        jQueryOTD(
          ".additional-checkout-buttons, .dynamic-checkout__content"
        ).hide();
  });
}
function oddt_time_dropdown_format_zero(e, t, a, r) {
  var i = e.delivery_time.time,
    s = find_separator_date(e.date_format),
    d = formatDate(e.today_date.date),
    n = (d = d.split("-"))[0],
    o = d[1],
    l = d[2],
    _ = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      s,
      (_ = l + "-" + o + "-" + n)
    ),
    d = convertFixDate(a, "mm-dd-yy"),
    l = new Date(d),
    o = ("0" + l.getDate()).slice(-2),
    n = ("0" + (l.getMonth() + 1)).slice(-2),
    l = l.getFullYear(),
    m = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      s,
      (d = o + "-" + n + "-" + l)
    ),
    d = e.select_time_text;
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (d = e.sp_text_settings.store_pickup_timer_heading);
  var u = t,
    c = e.currentmonthday,
    y = r,
    p = e.currentHr,
    D = e.cutoff_time_status,
    f = e.cutoff_hour_minute;
  a = parseDate(a);
  for (
    var h = new Date(a).getDate(),
      v = oddt_month_text_value(a),
      g = "",
      a = "",
      d = '<option value="">' + d + "</option>",
      T = i.split(","),
      b = e.delivery_time.time_24,
      p = hide_slots_settings(e, p),
      O = 0;
    O < T.length;
    O++
  )
    t == u && parseInt(c) == parseInt(h) && y == v
      ? 0 != D &&
        ((1 == e.cutoff_time_status && m == _) ||
          (1 == e.cutoff_time_status &&
            1 == e.cutoff_time_min_day &&
            m == e.min_date &&
            0 != e.min_day_value))
        ? parseFloat(p) <= parseFloat(T[O]) &&
          parseFloat(p) <= parseFloat(f) &&
          (g += '<option value="' + b[O] + '">' + b[O] + "</option>")
        : parseFloat(p) <= parseFloat(T[O]) &&
          (g += '<option value="' + b[O] + '">' + b[O] + "</option>")
      : (g += '<option value="' + b[O] + '">' + b[O] + "</option>");
  return (a = "" != g ? d + g : a);
}
function oddt_time_dropdown_format_one(e, t, a, r) {
  var i = 0,
    s = e.delivery_time,
    d = e.select_time_text,
    n = find_separator_date(e.date_format),
    o = formatDate(e.today_date.date),
    l = (o = o.split("-"))[0],
    _ = o[1],
    m = o[2],
    u = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      n,
      (u = m + "-" + _ + "-" + l)
    ),
    c = convertFixDate(a, "mm-dd-yy"),
    y = new Date(c),
    p = ("0" + y.getDate()).slice(-2),
    o = ("0" + (y.getMonth() + 1)).slice(-2),
    m = y.getFullYear(),
    _ = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      n,
      (c = p + "-" + o + "-" + m)
    );
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (d = e.sp_text_settings.store_pickup_timer_heading);
  (l = t),
    (y = e.currentmonthday),
    (n = r),
    (p = e.currentHr),
    (o = e.cutoff_time_status),
    (m = e.cutoff_hour_minute);
  a = parseDate(a);
  for (
    var c = new Date(a).getDate(),
      r = oddt_month_text_value(a),
      D = "",
      a = "",
      d = '<option value="">' + d + "</option>",
      f = s.split(","),
      h = 0;
    h < f.length;
    h++
  )
    D += '<option value="' + f[h] + '">' + f[h] + "</option>";
  return (a =
    1 ==
    (i =
      0 == o ||
      t != l ||
      parseInt(y) != parseInt(c) ||
      n != r ||
      !(
        (1 == e.cutoff_time_status && _ == u) ||
        (1 == e.cutoff_time_status &&
          1 == e.cutoff_time_min_day &&
          _ == e.min_date &&
          0 != e.min_day_value)
      ) ||
      parseFloat(p) <= parseFloat(m)
        ? 1
        : i)
      ? d + D
      : a);
}
function get24hTime(e) {
  var t = 0 <= (e = String(e).toLowerCase().replace(/\s/g, "")).indexOf("am"),
    a = 0 <= e.indexOf("pm");
  (e = e.replace("am", "").replace("pm", "")).indexOf(":") < 0 && (e += ":00"),
    t && (e += " am"),
    a && (e += " pm");
  (a = new Date("1/1/2011 " + e)),
    (e = function (e) {
      return parseInt(e) < 10 ? "0" + e : String(e);
    });
  return e(a.getHours()) + ":" + e(a.getMinutes());
}
function oddt_time_dropdown_format_three(e, t, a, r) {
  var i = t,
    s = t,
    d = e.currentmonthday,
    n = r,
    o = e.currentHr,
    l = e.cutoff_time_status,
    _ = e.cutoff_hour_minute,
    m = e.select_time_text,
    u = find_separator_date(e.date_format),
    c = formatDate(e.today_date.date),
    y = (c = c.split("-"))[0],
    p = c[1],
    r = c[2],
    D = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      u,
      (D = r + "-" + p + "-" + y)
    ),
    c = convertFixDate(a, "mm-dd-yy"),
    r = new Date(c),
    p = ("0" + r.getDate()).slice(-2),
    y = ("0" + (r.getMonth() + 1)).slice(-2),
    r = r.getFullYear(),
    f = dateFormatConvert(
      "dd-mm-yy",
      e.date_format,
      "-",
      u,
      (c = p + "-" + y + "-" + r)
    );
  "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
    (m = e.sp_text_settings.store_pickup_timer_heading);
  var h = e.delivery_time,
    v = e.time_display_format;
  a = parseDate(a);
  var g,
    T,
    b,
    O = new Date(a).getDate(),
    j = oddt_month_text_value(a),
    a = [];
  g =
    null == e.day_arr
      ? [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Special",
        ]
      : e.day_arr;
  for (
    var w,
      Q,
      x = [],
      A = [],
      I = [],
      S = [],
      k = [],
      o = hide_slots_settings(e, o),
      J = 1 == (J = e.is_show_hide_slot) ? "start" : "end",
      R = 0;
    R < h.length;
    R++
  )
    if (i == g[R])
      for (T = 0; T < h[R].end.length; T++) {
        Q =
          12 == v
            ? ((b = get24hTime(h[R].end[T]).split(":")),
              (temp_start = get24hTime(h[R].start[T]).split(":")),
              (E = h[R].start[T].split(":")),
              (q = h[R].end[T].split(":")),
              4 != E[1].length && 4 != q[1].length
                ? ((w = oddt_convert_24_to_12(E)), oddt_convert_24_to_12(q))
                : ((w = h[R].start[T]), h[R].end[T]))
            : ((b = h[R].end[T].split(":")),
              (temp_start = h[R].start[T].split(":")),
              (w = h[R].start[T]),
              h[R].end[T]);
        var F,
          L,
          C = h[R].pre[T],
          N = h[R].post[T],
          M = h[R].to[T],
          P = h[R].limit_status[T],
          E = h[R].number_orders[T],
          q = 0;
        t == s && parseInt(d) == parseInt(O) && n == j
          ? 0 == l
            ? "start" == J && 1 == e.hide_slots_settings
              ? parseFloat(o) <= parseFloat(temp_start[0]) &&
                parseFloat(o) <= parseFloat(b[0]) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
              : "end" == J && 1 == e.hide_slots_settings
              ? parseFloat(o) <= parseFloat(b[0]) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
              : (q = 1)
            : "start" == J && 1 == e.hide_slots_settings
            ? (1 == e.cutoff_time_status && f == D) ||
              (1 == e.cutoff_time_status &&
                1 == e.cutoff_time_min_day &&
                f == e.min_date &&
                0 != e.min_day_value)
              ? parseFloat(e.currentHr) <= parseFloat(temp_start[0]) &&
                parseFloat(e.currentHr) <= parseFloat(b[0]) &&
                parseFloat(e.currentHr) <= parseFloat(_) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
              : parseFloat(e.currentHr) <= parseFloat(temp_start[0]) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
            : "end" == J && 1 == e.hide_slots_settings
            ? (1 == e.cutoff_time_status && f == D) ||
              (1 == e.cutoff_time_status &&
                1 == e.cutoff_time_min_day &&
                f == e.min_date &&
                0 != e.min_day_value)
              ? parseFloat(e.currentHr) <= parseFloat(b[0]) &&
                parseFloat(e.currentHr) <= parseFloat(_) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
              : parseFloat(e.currentHr) <= parseFloat(b[0]) &&
                ((L = C + " " + w + " " + M + " " + Q + " " + N),
                x.push((F = w + "-" + Q)),
                A.push(L),
                1 == P && 0 == E && k.push(F),
                I.push(P),
                S.push(E))
            : (1 == e.cutoff_time_status && f == D) ||
              (1 == e.cutoff_time_status &&
                1 == e.cutoff_time_min_day &&
                f == e.min_date &&
                0 != e.min_day_value)
            ? 0 == e.hide_slots_settings &&
              parseFloat(e.currentHr) <= parseFloat(_) &&
              ((L = C + " " + w + " " + M + " " + Q + " " + N),
              x.push((F = w + "-" + Q)),
              A.push(L),
              1 == P && 0 == E && k.push(F),
              I.push(P),
              S.push(E))
            : (q = 1)
          : (q = 1),
          q &&
            ((L = C + " " + w + " " + M + " " + Q + " " + N),
            x.push((F = w + "-" + Q)),
            A.push(L),
            1 == P && 0 == E && k.push(F),
            I.push(P),
            S.push(E));
      }
  if (
    (a.push(x.toString().split(",")),
    a.push(A.toString().split(",")),
    a.push(I.toString().split(",")),
    a.push(S.toString().split(",")),
    "" != a[0])
  ) {
    var V = '<option value="">' + m + "</option>",
      $ = order_limit_time_format(
        e,
        "" == jQueryOTD(".uiDeliveryDateVal").val() ||
          null == jQueryOTD(".uiDeliveryDateVal").val()
          ? e.min_date
          : jQueryOTD(".uiDeliveryDateVal").val(),
        e.all_orders,
        a[0],
        a[1],
        a[2],
        a[3]
      );
    k.forEach(function (e, t) {
      -1 < jQueryOTD.inArray(e, $[0]) &&
        ((e = $[0].indexOf(e)),
        delete $[0][e],
        delete $[1][e],
        delete $[2][e],
        delete $[3][e]);
    });
    for (var H = 0; H < $[1].length; H++)
      void 0 !== $[0][H] &&
        (V += '<option value="' + $[0][H] + '">' + $[1][H] + "</option>");
    a = V;
  }
  return a;
}
function dateFormatConvert_new(e, t, a, r, i) {
  (e = e.toLowerCase().split(a)), (i = i.split(a));
  (i[e[0]] = i[0]), (i[e[1]] = i[1]), (i[e[2]] = i[2]);
  a = t.toLowerCase().split(a);
  return (newDate = i[a[0]] + r + i[a[1]] + r + i[a[2]]), newDate;
}
function order_limit_time_format(e, t, a, r, i, s, d) {
  for (
    var n = [],
      o = e.date_format,
      e = o.charAt(2),
      t = dateFormatConvert_new(o, "yy" + e + "mm" + e + "dd", "" + e, "-", t),
      l = 0;
    l < a.length;
    l++
  ) {
    var _ = a[l].delivery_date,
      m = a[l].delivery_time;
    t == _ && n.push(m);
  }
  if (n.length) {
    var u = [];
    n.forEach(function (e) {
      u[e] = (u[e] || 0) + 1;
    });
    for (var c, y = 0; y < r.length; y++)
      1 == s[y] &&
        ((timer = null != u[r[y]] ? u[r[y]] : ""),
        "" != timer &&
          timer >= d[y] &&
          (delete r[y], delete i[y], delete s[y], delete d[y]));
    return ((c = [])[0] = r), (c[1] = i), (c[2] = s), (c[3] = d), c;
  }
  return ((c = [])[0] = r), (c[1] = i), (c[2] = s), (c[3] = d), c;
}
function auto_minday_calculation(e, t, a, r, i, s = "") {
  var d,
    n,
    e = t.temp_auto_date,
    o = t.temp_auto_current_week_day,
    l = r.charAt(2),
    l = dateFormatConvert_new(r, "mm" + l + "dd" + l + "yy", "" + l, "/", e),
    _ = new Date(l);
  for (
    "otd_shipping" == s && (d = _.setDate(_.getDate() - 1)),
      "otd_shipping" != s &&
        ((d = _.setDate(_.getDate() + 1)),
        (n = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
        o++,
        resultJson.auto_current_week_day++);
    -1 < jQueryOTD.inArray(o, a);

  )
    (d = _.setDate(_.getDate() + 1)),
      (n = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
      (o = new Date(n).getDay());
  for (; -1 < jQueryOTD.inArray(e, i); )
    for (
      d = _.setDate(_.getDate() + 1),
        n = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r),
        o = new Date(n).getDay();
      -1 < jQueryOTD.inArray(o, a);

    )
      (d = _.setDate(_.getDate() + 1)),
        (n = convertFixDate((e = oddt_get_date_formated(new Date(d), r)), r)),
        (o = new Date(n).getDay());
  t.auto_date = e;
}
function oddt_before_show_days(e, t, a, r, i) {
  var s = e.getDay(),
    i = (new Date(e), i.current_time_c, i.active_addon);
  return -1 < t.indexOf(s)
    ? [!1, "booked", ""]
    : (jQueryOTD.inArray("2", i), [!0, "", ""]);
}
function get_order_data_of_month(t, e) {
  jQueryOTD.ajax({
    type: "POST",
    url: SITE_FILE_URL,
    data: {
      method_name: "get_selected_month_order",
      shop: shopName,
      date: e,
      store_client_id: t.store_client_id,
    },
    dataType: "json",
    success: function (e) {
      t.order_data = e;
    },
    error: function () {
      console.log("Error on get data of selected month");
    },
  });
}
function bindDatePicker(t, e, a, r, i, s, d, n, o) {
  var l = n.auto_date;
  resultJson = n;
  var _ = a.replace("yy", "yyyy"),
    r = r.split(","),
    m = [];
  jQueryOTD.each(r, function (e, t) {
    m.push(t.substring(0, 3));
  });
  var u,
    i = i.split(","),
    c = [],
    y = [];
  jQueryOTD.each(i, function (e, t) {
    c.push(t.substring(0, 3)), y.push(t);
  }),
    (jQueryOTD.fn.bootstrapDP.dates.en = {
      months: r,
      days: i,
      daysShort: y,
      daysMin: y,
      monthsShort: m,
      titleFormat: "MM yyyy",
    }),
    jQueryOTD(".uiDeliveryCalendar")
      .bootstrapDP({
        format: _,
        startDate: l,
        endDate:
          0 < n.max_day
            ? new Date(
                new Date().setDate(new Date().getDate() + (n.max_day - 1))
              )
            : null,
        datesDisabled: resultJson.extra_no_available,
        daysOfWeekDisabled: t,
        weekStart: e,
        autoclose: !0,
        orientation: "bottom left",
        beforeShowDay: function (e) {
          return oddt_before_show_days(e, t, s, a, n);
        },
      })
      .on("changeMonth", function (e) {
        var t, a, r, i;
        o
          ? ((i = ("0" + (a = new Date(e.date)).getDate()).slice(-2)),
            (r = ("0" + (a.getMonth() + 1)).slice(-2)),
            (t = a.getFullYear()),
            get_order_data_of_month(resultJson, t + "-" + r + "-" + i))
          : ((r = ("0" + ((a = new Date(e.date)).getMonth() + 1)).slice(-2)),
            (i = a.getFullYear()),
            1 == resultJson.timer_status &&
              1 == resultJson.time_format &&
              ((e = "01/" + r + "/" + i),
              (a =
                null != resultJson.location_id
                  ? resultJson.location_id
                  : "IS NULL"),
              (r = 0),
              "Store Pickup" == jQueryOTD(".uiLocationOrderTypeVal").val() &&
                ((a = jQueryOTD(".uiLocationIdVal").val()), (r = 1)),
              ((i = {}).shop = shopName),
              (i.oddShopInfo = resultJson.oddShopInfo),
              (i.min_date = e),
              (i.extra_no_available = resultJson.extra_no_available),
              (i.timer_status = resultJson.timer_status),
              (i.date_format = resultJson.date_format),
              (i.time_format = resultJson.time_format),
              (i.delivery_time = resultJson.time_format_value),
              (i.location_id = a),
              (i.order_type = r),
              (i.method_name = "dds_addon_order_data"),
              jQueryOTD.ajax({
                type: "POST",
                url: SITE_FILE_URL,
                data: i,
                async: !1,
                success: function (e) {
                  (addonOrderData = JSON.parse(e)),
                    (s =
                      "" != s
                        ? s + "," + addonOrderData.extra_no_available
                        : addonOrderData.extra_no_available),
                    (resultJson.extra_no_available = s),
                    (resultJson.all_orders_status =
                      addonOrderData.all_orders_status),
                    (resultJson.all_orders = addonOrderData.all_orders);
                },
              })));
      })
      .on("changeDate", function (e) {
        e = new Date(e.date);
        date_select(
          ("0" + e.getDate()).slice(-2) +
            "-" +
            ("0" + (e.getMonth() + 1)).slice(-2) +
            "-" +
            e.getFullYear(),
          a,
          n,
          o
        );
      }),
    1 == resultJson.cal_type &&
      jQueryOTD(".identixweb-order-delivery-datepicer-icon").bind(
        "click",
        ".order-calendar-button-click",
        function (e) {
          jQueryOTD(e.delegateTarget).find(".uiDeliveryCalendar").focus();
        }
      ),
    setTimeout(function () {
      jQueryOTD(".appsonrent-dds-local-delivery-preloader").hide(),
        jQueryOTD(".appsonrent-dds-main").show(),
        jQueryOTD(".order-delivery-date-local-delivery").show(),
        jQueryOTD(".appsonrent-dds-store-pickup").show(),
        jQueryOTD(
          ".store_loader .identixweb-order-delivery-date-store-pickup"
        ).show();
    }, 300),
    (map_load = 0) == map_load &&
      1 == jQueryOTD(".storePickupTab").hasClass("active_tab") &&
      null != resultJson.google_map_status &&
      1 == resultJson.google_map_status &&
      (u = setInterval(function () {
        0 < jQueryOTD("#oddGoogleMap").length &&
          (initMap(resultJson), clearInterval(u));
      }, 1e3));
}
function date_select(e, t, a, r) {
  var i,
    s,
    d = e,
    n = "",
    o = oddt_month_text_value(parseDate(a.current_time_c)),
    l = find_separator_date(t);
  (e =
    "dd.mm.yy" == t || "dd/mm/yy" == t || "dd-mm-yy" == t
      ? ((i = dateFormatConvert("dd-mm-yy", t, "-", l, d)),
        (i =
          "dd.mm.yy" == resultJson.convert_date_format
            ? i.replace(/[/,\s]/g, ".").replace(/[-,\s]/g, ".")
            : i),
        (s = oddt_day_text_value(
          convertFixDate(
            (_ = dateFormatConvert("yy-mm-dd", t, "-", l, d)),
            "yy-mm-dd"
          )
        )),
        oddt_day_text_value_DAY(convertFixDate(_, "yy-mm-dd")))
      : ((i = dateFormatConvert("dd-mm-yy", t, "-", l, d)),
        (_ = dateFormatConvert("dd-mm-yy", t, "-", l, d)),
        (s = oddt_day_text_value(convertFixDate(i, t))),
        oddt_day_text_value_DAY(convertFixDate(i, t)))),
    jQueryOTD(".uiDeliveryDateVal").val(i),
    jQueryOTD(".uiDeliveryDayVal").val(s),
    jQueryOTD(".deliveryTime").empty(),
    "NULL" === a.timer_status || r || (n = oddt_get_time_slots(a, s, _, o)),
    "NULL" !== a.timer_status &&
      r &&
      (n = date_change_onTimeDel_function(a, _, "changeDate")),
    jQueryOTD(".iw-otd-deliveryTime").html(n),
    (l =
      "1" == a.timer_status
        ? "attributes[" +
          a.delivery_date_text +
          "]=" +
          i +
          "&attributes[" +
          a.delivery_day_text +
          "]=" +
          e +
          "&attributes[" +
          a.delivery_time_text +
          "]&update"
        : "attributes[" +
          a.delivery_date_text +
          "]=" +
          i +
          "&attributes[" +
          a.delivery_day_text +
          "]=" +
          e +
          "&update");
  var d = jQueryOTD(".uiLocationOrderTypeVal").val(),
    t = jQueryOTD(".uiLocationNameVal").val(),
    o = jQueryOTD(".uiLocationAddressVal").val(),
    _ = jQueryOTD(".uiLocationIdVal").val();
  "Shipping" == d
    ? ((n = r ? "" : "Shipping"),
      r && jQueryOTD(".uiLocationOrderTypeVal").val(""),
      (l =
        "1" == a.timer_status
          ? "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            s +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=" +
            n +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            e +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=" +
            n +
            "&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"))
    : "Store Pickup" == d &&
      (l =
        "1" == a.timer_status
          ? "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            s +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=Store Pickup&attributes[Location Id]=&attributes[Location Name]=&attributes[Location Address]=&attributes[Postal Code]=&update"
          : "attributes[" +
            a.delivery_date_text +
            "]=" +
            i +
            "&attributes[" +
            a.delivery_day_text +
            "]=" +
            e +
            "&attributes[" +
            a.delivery_time_text +
            "]=&attributes[Order Type]=Store Pickup&attributes[Location Id]=" +
            _ +
            "&attributes[Location Name]=" +
            t +
            "&attributes[Location Address]=" +
            o +
            "&attributes[Postal Code]=&update"),
    jQueryOTD(
      '.iw-otd-deliveryTime option[value="' + a.cart_delivery_time + '"]'
    ).attr("selected", "selected"),
    jQueryOTD(".iw-otd-deliveryTime").trigger("change"),
    jQueryOTD.ajax({
      url: "/cart",
      data: l,
      type: "POST",
      dataType: "text",
      async: !1,
    });
}
function oddt_convert_24_to_12(e) {
  var t;
  return (
    (t = 0 == e[0] ? 12 : e[0]),
    12 < e[0]
      ? parseInt(e[0] - 12) < 10
        ? "0" + parseInt(e[0] - 12) + ":" + e[1] + "PM"
        : parseInt(e[0] - 12) + ":" + e[1] + "PM"
      : 12 == e[0]
      ? parseInt(e[0]) + ":" + e[1] + "PM"
      : t + ":" + e[1] + "AM"
  );
}
function oddt_get_date_formated(e, t) {
  var a, r;
  (a =
    parseInt(e.getMonth() + 1) < 10
      ? "0" + parseInt(e.getMonth() + 1)
      : parseInt(e.getMonth() + 1)),
    (r = e.getDate() < 10 ? "0" + e.getDate() : e.getDate());
  var i = e.getFullYear(),
    s = "";
  switch (t) {
    case "dd/mm/yy":
      s = r + "/" + a + "/" + i;
      break;
    case "dd/yy/mm":
      s = r + "/" + i + "/" + a;
      break;
    case "mm/dd/yy":
      s = a + "/" + r + "/" + i;
      break;
    case "mm/yy/dd":
      s = a + "/" + i + "/" + r;
      break;
    case "yy/dd/mm":
      s = i + "/" + r + "/" + a;
      break;
    case "yy/mm/dd":
      s = i + "/" + a + "/" + r;
      break;
    case "dd-mm-yy":
      s = r + "-" + a + "-" + i;
      break;
    case "dd-yy-mm":
      s = r + "-" + i + "-" + a;
      break;
    case "mm-dd-yy":
      s = a + "-" + r + "-" + i;
      break;
    case "mm-yy-dd":
      s = a + "-" + i + "-" + r;
      break;
    case "yy-dd-mm":
      s = i + "-" + r + "-" + a;
      break;
    case "yy-mm-dd":
      s = i + "-" + a + "-" + r;
  }
  return s;
}
function hulkappsCheckoutClick() {
  if ("1" != on_time_appsStatus) return !0;
  var e = !1;
  return (
    "1" == on_time_use_time_option
      ? (("1" == on_time_required_delivery_date &&
          jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val() &&
          jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()) ||
          "0" == on_time_required_delivery_date) &&
        (e = !0)
      : (("1" == on_time_required_delivery_date &&
          jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()) ||
          "0" == on_time_required_delivery_date) &&
        (e = !0),
    e
  );
}
function oddt_day_text_value_DAY(e) {
  var t = delivery_days,
    a = parseDate(e);
  new Date(a);
  return t[e.getDay()];
}
Shopify.Checkout &&
  void 0 !== Shopify.Checkout.OrderStatus &&
  (("thank_you" != Shopify.Checkout.page && !Shopify.checkout.order_id) ||
    (((data = {}).shop = Shopify.shop),
    (data.method_name = "select_settings_text"),
    (data.order_id = Shopify.checkout.order_id),
    jQueryOTD.ajax({
      type: "POST",
      url: SITE_FILE_URL,
      data: data,
      dataType: "json",
      success: function (e) {
        var t, a;
        null != e.settings.show_on_thankyou &&
          "1" == e.settings.show_on_thankyou &&
          void 0 !== e.orders &&
          "success" == e.msg &&
          ((t = e.orders.delivery_date),
          void 0 === e.orders.api_call &&
            ((a = find_separator_date(e.settings.date_format)),
            (t = dateFormatConvert(
              "yy-mm-dd",
              e.settings.date_format,
              "-",
              "" + a,
              t
            ))),
          (a = '<div class="content-box"><div class="content-box__row">'),
          "" != e.settings.box_title_text &&
            (1 == e.orders.order_type
              ? (a +=
                  '<h2 class="os-step__title">' +
                  e.sp_title_text_settings +
                  "</h2>")
              : (a +=
                  '<h2 class="os-step__title">' +
                  e.settings.box_title_text +
                  "</h2>")),
          "" != e.orders.delivery_time
            ? (a +=
                '<div class="os-step__special-description"><p class="iweb-dt-delivery_date"><strong>' +
                e.settings.delivery_date +
                " : </strong> <span>" +
                t +
                '</span></p><p class="iweb-dt-delivery_time" style="margin-top:0"><strong>' +
                e.settings.delivery_time +
                " : </strong> <span>" +
                e.orders.delivery_time +
                "</span></p>")
            : (a +=
                '<div class="os-step__special-description"><p class="iweb-dt-delivery_date"><strong>' +
                e.settings.delivery_date +
                " : </strong> <span>" +
                t +
                "</span></p>"),
          1 == e.orders.order_type &&
            (a +=
              '<p class="iweb-dt-delivery_address"><strong> Store Pickup Address : </strong> <span>' +
              e.orders.location_address +
              "</span></p>"),
          (a += "</div></div></div>"),
          window.Checkout.$(
            ".content .section:nth-child(3) .content-box:first-child"
          ).after(a),
          window.Checkout.$(".iweb-dt-delivery_date").length ||
            window.Checkout.$(
              ".content .section:nth-child(2) .content-box:first-child"
            ).after(a));
      },
    }))),
  window.RevyBundle &&
    (window.RevyBundle.api.checkoutValidator = function () {
      if ("1" != on_time_appsStatus) return !0;
      var e = !1;
      return (
        "1" == on_time_use_time_option
          ? (("1" == on_time_required_delivery_date &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val() &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryTimeVal").val()) ||
              "0" == on_time_required_delivery_date) &&
            (e = !0)
          : (("1" == on_time_required_delivery_date &&
              "" != jQueryOTD(".iw-order-delivery-dt-deliveryDateVal").val()) ||
              "0" == on_time_required_delivery_date) &&
            (e = !0),
        e
      );
    });
